console.log('[FE_r] V 1.0.39');
import { Constants } from './v2-fgen-constants.js';
import { FE$MultiLevelChoiceRenderer } from './v2-fgen-render-extensions.js';
import { fe$utils, FE$OptionHelper, FEngineException, FE$BaseRenderer, FE$BaseValidator } from './v2-fgen-fengine.js';

/* -------------------- TEXT RENDERER ----------------------- */
function FE$TextRenderer() {
   this._langSvc = null;
   this._input = null;
   this._label = null;
}
FE$TextRenderer.prototype = new FE$BaseRenderer();

FE$TextRenderer.prototype.getType = function () {
   return 'text';
}
FE$TextRenderer.prototype.getValue = function () {
   return this._input.value;
}

FE$TextRenderer.prototype.setValue = function (v) {
   if (v == null || v == undefined) {
      v = '';
   }
   this._input.value = v;

   //FIXME! : this is template dependant, is only need in form02 
   if (!this._input.classList.contains("floating-label-top") && this._input.value)
      this._input.classList.add("floating-label-top");

   this.notifyChange();
}


FE$TextRenderer.prototype.lock = function (doLock) {
   console.log('[FER_Txt] Locking: ' + doLock);
   if (doLock) {
      this._input.setAttribute('disabled', true);
   } else {
      this._input.removeAttribute('disabled');
   }
}
FE$TextRenderer.prototype.translateTo = function (lang) {
   var def = this.getDefinition();
   var langSvc = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.childNodes[0])
      }
      this._label.innerHTML = langSvc(def.label, lang);
   }
   if (def.placeholder) {
      this._input.setAttribute('placeholder', langSvc(def.placeholder, lang));
   }
}
FE$TextRenderer.prototype._onFocus = function () {
   console.log('FOCUSED!!');
   fe$utils.addClass('FE-state-focus', this.getElement());
}
FE$TextRenderer.prototype._onBlur = function () {
   console.log('BLURRED!!');
   if(!this._input.value)
      fe$utils.removeClass('FE-state-focus', this.getElement());
}
FE$TextRenderer.prototype._onChange = function () {
   this.notifyChange();
}
FE$TextRenderer.prototype.render = function (where, lang) {
   console.log('[FER] Called string render')
   var def = this.getDefinition();

   // var container = this.getElement();
   if (def.label) {
      this._label = document.createElement('label')
      // this.label.appendChild(document.createTextNode(def.label))
      this._label.setAttribute('class', 'FE-controlR-label FE-textR-label');
      where.appendChild(this._label);
   }

   this._input = document.createElement('input');

   this._input.addEventListener('focus', this._onFocus.bind(this));
   this._input.addEventListener('blur', this._onBlur.bind(this));
   this._input.addEventListener('blur', this._onChange.bind(this));

   this._input.setAttribute('name', def.name);
   this._input.setAttribute('type', 'text')
   this._input.setAttribute('class', 'FE-controlR-control FE-textR-control')
   if(def.hasOwnProperty('tabIndex'))   
      this._input.setAttribute('tabIndex', def.tabIndex)

   where.appendChild(this._input);

   this.translateTo(lang);

}

/* -------------------- LONG TEXT RENDERER ----------------------- */

function FE$LongTextRenderer() {
   this._langSvc = null;
   this._input = null;
   this._label = null;
}
FE$LongTextRenderer.prototype = new FE$BaseRenderer();

FE$LongTextRenderer.prototype.getType = function () {
   return 'text';
}
FE$LongTextRenderer.prototype.getVariant = function () {
   return 'long';
}
FE$LongTextRenderer.prototype.getValue = function () {
   return this._input.value;
}

FE$LongTextRenderer.prototype._onFocus = function () {
   console.log('FOCUSED!!');
   fe$utils.addClass('FE-state-focus', this.getElement());
}
FE$LongTextRenderer.prototype._onBlur = function () {
   console.log('BLURRED!!');
   if(!this._input.value)
   fe$utils.removeClass('FE-state-focus', this.getElement());
}

FE$LongTextRenderer.prototype.translateTo = function (lang) {
   // console.log('[feLTR] Called translate to for lang: ' + lang);
   var def = this.getDefinition();
   // console.log('[feLTR] Obtained definition: ' + def);
   var langSvc = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.childNodes[0])
      }
      this._label.appendChild(document.createTextNode(langSvc(def.label, lang)));
   }
   if (def.placeholder) {
      this._input.setAttribute('placeholder', langSvc(def.placeholder, lang));
   }
}
FE$LongTextRenderer.prototype.render = function (where, lang) {
   console.log('[FER] Called string render')
   var def = this.getDefinition();

   // var container = this.getElement();
   if (def.label) {
      this._label = document.createElement('label')
      // this.label.appendChild(document.createTextNode(def.label))
      this._label.setAttribute('class', 'FE-controlR-label FE-textR-label');
      where.appendChild(this._label);
   }

   this._input = document.createElement('textarea');
   this._input.addEventListener('focus', this._onFocus.bind(this));
   this._input.addEventListener('blur', this._onBlur.bind(this));

   this._input.setAttribute('name', def.name);
   this._input.setAttribute('class', 'FE-controlR-control FE-textR-control FE-textArea')
   if(def.hasOwnProperty('tabIndex'))   
      this._input.setAttribute('tabIndex', def.tabIndex)

   where.appendChild(this._input);

   this.translateTo(lang);

}

FE$LongTextRenderer.prototype.lock = function (doLock) {
   console.log('[FER_Ltxt] Locking: ' + doLock);
   if (doLock) {
      this._input.setAttribute('disabled', true);
   } else {
      this._input.removeAttribute('disabled');
   }
}

/* -------------------- BUTTON RENDERER ----------------------- */
function FE$ButtonRenderer() {
   this._input = null;
}
FE$ButtonRenderer.prototype = new FE$BaseRenderer();

FE$ButtonRenderer.prototype.getType = function () {
   return 'button';
}
FE$ButtonRenderer.prototype.isValueControl = function () {
   return false;
}
FE$ButtonRenderer.prototype.translateTo = function (lang) {
   console.log('[feBR] Called translate to ' + lang);
   var def = this.getDefinition();
   console.log('[feBR] Obtained definition: ' + def);
   var langSvc = this.getTranslator();
   this._input.setAttribute('value', langSvc(def.label, lang));
}
FE$ButtonRenderer.prototype.render = function (where, lang) {
   console.log('[feBR] Called render')
   var def = this.getDefinition();

   this._input = document.createElement('input');
   this._input.setAttribute('type', 'button');

   where.appendChild(this._input);

   if (def.onclick) {
      var fnc = null;
      if (def.onclick in window) { // Direct invocation
         fnc = window[def.onclick];
      } else { // Use fexi executor
         var proxy = this.getProxy();
         fnc = proxy.fexExecuteString.bind(proxy, def.onclick);
      }
      this._input.addEventListener('click', fnc);
   }
   this.translateTo(lang);
}

FE$ButtonRenderer.prototype.lock = function (doLock) {
   console.log('[feBR] Locking: ' + doLock);
   if (doLock) {
      this._input.setAttribute('disabled', true);
   } else {
      this._input.removeAttribute('disabled');
   }
}


/* -------------------- SUBMIT RENDERER ----------------------- */
function FE$SubmitRenderer() {
   // Construct with super class
   FE$ButtonRenderer.call(this);
}
FE$SubmitRenderer.prototype = new FE$ButtonRenderer();

FE$SubmitRenderer.prototype.getType = function () {
   return 'submit';
}

FE$SubmitRenderer.prototype.render = function (where, lang) {
   console.log('[feSR] Called render')
   // Call superclass
   Object.getPrototypeOf(FE$SubmitRenderer.prototype).render.call(this, where, lang);
   // Set on click
   this._input.addEventListener('click', fe$ngine.doSubmit);

}




/* -------------------- CHOICE RENDERER ----------------------- */
function FE$ChoiceRenderer() {
   this._label;
   this._input;
   this._options;
}

FE$ChoiceRenderer.prototype = new FE$BaseRenderer();

FE$ChoiceRenderer.prototype.getType = function () {
   return 'choice';
}
FE$ChoiceRenderer.prototype.getValue = function () {

   return this._input.value;
}

FE$ChoiceRenderer.prototype.setValue = function (v) {
   this._input.value = v;
   this._input.selectedIndex = 0;
   for (var i = 0; i < this._input.childNodes.length; i++) {
      if (this._input.childNodes[i].value == v) {
         console.log('[FER_cr] Found option for value ' + v + ' -> ' + i);
         this._input.selectedIndex = i;
      }
   }
   //FIXME! : this is template dependant, is only need in form02 
   if (!this._input.classList.contains("floating-label-top"))
      this._input.classList.add("floating-label-top");

   this.notifyChange();
}

FE$ChoiceRenderer.prototype.translateTo = function (lang) {
   var def = this.getDefinition();
   var translate = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.firstChild)
      }
      this._label.innerHTML = translate(def.label, lang)
   }
   for (var i = 0; i < this._options.length; i++) {
      if (this._options[i].hasChildNodes()) {
         this._options[i].removeChild(this._options[i].firstChild);
      }
   }
   var offset = 0;
   if (def.placeholder) {
      this._options[0].appendChild(document.createTextNode(translate(def.placeholder, lang)))
      offset = 1; // Options include a placeholder..so real options are offsetted

   }
   for (var i = offset; i < this._options.length; i++) {
      this._options[i].appendChild(document.createTextNode(translate(def.options[i - offset].label, lang)))
   }
}
FE$ChoiceRenderer.prototype.render = function (where, lang) {
   console.log('[FER] Called string render')
   // var container = this.getElement();
   var def = this.getDefinition();
   if (def.label) {
      this._label = document.createElement('label')

      this._label.setAttribute('class', 'FE-controlR-label FE-stringR-label');
      where.appendChild(this._label);
   }

   this._input = document.createElement('select');
   this._input.addEventListener('change', function () {
      this.notifyChange();
   }.bind(this));
   this._options = new Array();
   if (def.placeholder) {
      var option = document.createElement('option');
      option.setAttribute('value', '')
      this._input.appendChild(option);
      this._options.push(option);
   }
   if (def.options) {

      for (var i = 0; i < def.options.length; i++) {
         var option = document.createElement('option');
         option.setAttribute('value', def.options[i].value)
         this._input.appendChild(option);
         this._options.push(option);
      }
   }
   this._input.setAttribute('class', 'FE-controlR-control FE-choiceR-control')
   if(def.hasOwnProperty('tabIndex'))   
      this._input.setAttribute('tabIndex', def.tabIndex)

   where.appendChild(this._input);
   this.translateTo(lang);
}

FE$ChoiceRenderer.prototype.lock = function (doLock) {
   console.log('[FER_Ltxt] Locking: ' + doLock);
   if (doLock) {
      this._input.setAttribute('disabled', true);
   } else {
      this._input.removeAttribute('disabled');
   }
}

/* -------------------- TOAST RENDERER ----------------------- */
function FE$ToastRenderer() {
   this._toast = null;
   this._label = null;
   this._versionColors = {
      'warning': '#f3e121',
      'success': 'green',
      'info': 'grey',
      'error': 'red'
   }
}
FE$ToastRenderer.prototype = new FE$BaseRenderer();

FE$ToastRenderer.prototype.getType = function () {
   return 'toast';
}
FE$ToastRenderer.prototype.isValueControl = function () {
   return false;
}
FE$ToastRenderer.prototype.translateTo = function (lang) {
   console.log('translateTo toast')

   let newLabel = document.createElement('label')
   newLabel.appendChild(document.createTextNode(this.getDefinition().traductions[lang]));
   this._toast.replaceChild(newLabel, this._label);
   this._label = newLabel;
}
FE$ToastRenderer.prototype.render = function (where, lang) {
   console.log('render toast', where)
   var def = this.getDefinition();

   this._toast = document.createElement('span')
   this._toast.setAttribute('class', 'FE-controlR-toast');

   this._toast.style.backgroundColor = this._versionColors[def.version] || 'red';

   console.log('append Toast');
   this._label = document.createElement('label')
   this._label.style.backgroundColor = "transparent";
   this._label.appendChild(document.createTextNode(def.traductions[lang]));
   this._toast.appendChild(this._label)
   let closeButton = document.createElement('button')
   closeButton.innerHTML = 'X'
   closeButton.addEventListener('click', (e) => { 
      e.preventDefault(); 
      e.stopPropagation(); 
      document.querySelector('.FE-toastWrapperR').style='display:none'
 });
   this._toast.appendChild(closeButton)
   where.prepend(this._toast);

   //this.translateTo(lang);
}

/* -------------------- LABEL RENDERER ----------------------- */
function FE$LabelRenderer() {
   this._label;
}
FE$LabelRenderer.prototype = new FE$BaseRenderer();

FE$LabelRenderer.prototype.getType = function () {
   return 'label';
}
FE$LabelRenderer.prototype.isValueControl = function () {
   return false;
}
FE$LabelRenderer.prototype.translateTo = function (lang) {
   var def = this.getDefinition();
   var translate = this.getTranslator();
   if (this._label) {
      var text = translate(def.label, lang)
      console.log('Translation for label ' + def.label + ' is ' + text)
      this._label.innerHTML = text
   }
}
FE$LabelRenderer.prototype.render = function (where, lang) {
   var def = this.getDefinition();
   if (def.label) {
      this._label = document.createElement('span')
      // this._label.appendChild(document.createTextNode(def.label))
      // this._label.innerHTML = def.label;
      this._label.setAttribute('class', 'FE-controlR-label');
      where.appendChild(this._label);

   }
   this.translateTo(lang);
}
FE$LabelRenderer.prototype.setValue = function (value) {
   console.log('[FELabel] changing value to', value)
   this._label.innerHTML = value
}

/* -------------------- RADIO RENDERER ----------------------- */
function FE$RadioChoiceRenderer() {
   this._label;
   this._rContainer;
   this._radios = new Array();
   this._radioLabels = new Array();
}

FE$RadioChoiceRenderer.prototype = new FE$BaseRenderer();

FE$RadioChoiceRenderer.prototype.getType = function () {
   return 'choice';
}

FE$RadioChoiceRenderer.prototype.getVariant = function () {
   return 'radio'
}
FE$RadioChoiceRenderer.prototype.getValue = function () {

   for (var i = 0; i < this._radios.length; i++) {
      var radio = this._radios[i]
      if (radio.checked) {
         return radio.value;
      }
   }
   return null
}
FE$RadioChoiceRenderer.prototype.translateTo = function (lang) {
   console.log('Translating radio');
   var def = this.getDefinition();
   var translate = this.getTranslator();
   for (var i = 0; i < this._radioLabels.length; i++) {
      while (this._radioLabels[i].hasChildNodes()) {
         this._radioLabels[i].removeChild(this._radioLabels[i].firstChild)
      }

      // this._radioLabels[i].appendChild(document.createTextNode(translate(def.options[i].label, lang)));
      this._radioLabels[i].innerHTML = translate(def.options[i].label, lang)
   }
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.firstChild)
      }
      this._label.innerHTML = translate(def.label, lang)
   }

}
FE$RadioChoiceRenderer.prototype.render = function (where, lang) {
   console.log('[FER] Called string render')
   // var container = this.getElement();
   var def = this.getDefinition();
   if (def.label) {
      this._label = document.createElement('label')
      this._label.appendChild(document.createTextNode(def.label))
      this._label.setAttribute('class', 'FE-controlR-label FE-choiceR-label');
      where.appendChild(this._label);
   }

   this._rContainer = document.createElement('div');
   this._rContainer.setAttribute('class', 'FE-choiceR-radios');
   where.appendChild(this._rContainer);
   if (def.options) {
      for (var i = 0; i < def.options.length; i++) {
         var rDiv = document.createElement('div');
         rDiv.setAttribute('class', 'FE-choiceR-radiolayer')
         this._rContainer.appendChild(rDiv);

         var radio = document.createElement('input');
         radio.setAttribute('class', 'FE-controlR-control FE-choiceR-control')
         radio.setAttribute('type', 'radio');
         radio.setAttribute('value', def.options[i].value);
         radio.setAttribute('name', def.name);
         if(def.hasOwnProperty('tabIndex'))   
            radio.setAttribute('tabIndex', def.tabIndex)
   
      
         rDiv.appendChild(radio);

         var rLabel = document.createElement('label');
         // rLabel.appendChild(document.createTextNode(def.options[i].label));
         rDiv.appendChild(rLabel);
         this._radios.push(radio);
         this._radioLabels.push(rLabel);


      }
   }
   this.translateTo(lang);

}

FE$RadioChoiceRenderer.prototype.lock = function (doLock) {
   console.log('[FER_Ltxt] Locking: ' + doLock);
   for (var i = 0; i < this._radios.length; i++) {
      if (doLock) {
         this._radios[i].setAttribute('disabled', true);
      } else {
         this._radios[i].removeAttribute('disabled');
      }
   }
}

/* -------------------- IMAGE RENDERER ----------------------- */
function FE$ImageRenderer() {
   this._image;
   this._alt;
}

FE$ImageRenderer.prototype = new FE$BaseRenderer();

FE$ImageRenderer.prototype.getType = function () {
   return 'image';
}

/* FE$ImageRenderer.prototype.getVariant = function() {
   return 'radio'
} */
FE$ImageRenderer.prototype.isValueControl = function () {
   return false;
}
FE$ImageRenderer.prototype.translateTo = function (lang) {
   console.log('Translating image');
   var def = this.getDefinition();
   var translate = this.getTranslator();
   if (def.alt) {
      var translation = translate(def.alt, lang);
      this._image.setAttribute('title', translation);
      if (this._alt) {
         while (this._alt.hasChildNodes()) {
            this._alt.removeChild(this._alt.firstChild);
         }

         this._alt.appendChild(document.createTextNode(translation));
      }
   }
}
FE$ImageRenderer.prototype.render = function (where, lang) {
   console.log('[FER] Called string render')
   // var container = this.getElement();
   var def = this.getDefinition();
   this._image = document.createElement('div');
   this._image.setAttribute('class', 'FE-controlR-image FE-imageR-image')

   this._image.style.backgroundImage = 'url(\'' + def.url + '\')';
   where.appendChild(this._image);

   if (def.alt) {
      this._alt = document.createElement('label');
      this._alt.setAttribute('class', 'FE-controlR-alt FE-imageR-alt')
      where.appendChild(this._alt);
   }
   this.translateTo(lang);

}

/* -------------------- CHECKBOX RENDERER ----------------------- */
function FE$CheckRenderer() {
   this._langSvc = null;
   this._input = null;
   this._label = null;
}
FE$CheckRenderer.prototype = new FE$BaseRenderer();

FE$CheckRenderer.prototype.getType = function () {
   return 'check';
}
FE$CheckRenderer.prototype.getValue = function () {
   return this._input.checked ? this._input.value : null;
}
FE$CheckRenderer.prototype.translateTo = function (lang) {
   var def = this.getDefinition();
   var langSvc = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.childNodes[0])
      }
      this._label.innerHTML = langSvc(def.label, lang);
   }
   if (def.placeholder) {
      this._input.setAttribute('placeholder', langSvc(def.placeholder, lang));
   }
}
FE$CheckRenderer.prototype.render = function (where, lang) {
   console.log('[FER] Called string render')
   var def = this.getDefinition();
   this._input = document.createElement('input');
   this._input.setAttribute('type', 'checkbox');
   this._input.setAttribute('name', def.name);
   this._input.setAttribute('value', def.value ? def.value : 'true');
   this._input.setAttribute('class', 'FE-controlR-control FE-checkR-control')
   if(def.hasOwnProperty('tabIndex'))   
         this._input.setAttribute('tabIndex', def.tabIndex)
   
   where.appendChild(this._input);

   if (def.label) {
      this._label = document.createElement('label')
      // this.label.appendChild(document.createTextNode(def.label))
      this._label.setAttribute('class', 'FE-controlR-label FE-checkR-label');
      where.appendChild(this._label);
   }
   this.translateTo(lang);

}

FE$CheckRenderer.prototype.lock = function (doLock) {
   console.log('[FER_Check] Locking: ' + doLock);
   if (doLock) {
      this._input.setAttribute('disabled', true);
   } else {
      this._input.removeAttribute('disabled');
   }
}

/* -------------------- DATE RENDERER ----------------------- */
function FE$DateRenderer() {
   this._langSvc = null;
   this._input = null;
   this._label = null;
   this._dpicker = null;

   this._i18n = {
      "es": {
         previousMonth: 'Mes Anterior',
         nextMonth: 'Mes Siguiente',
         months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
         weekdays: ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'],
         weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vier', 'Sab']
      },
      "ca": {
         previousMonth: 'Mes Anterior',
         nextMonth: 'Mes Següent',
         months: ['Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny', 'Juliol', 'Agost', 'Septembre', 'Octubre', 'Novembre', 'Decembre'],
         weekdays: ['Diumenge', 'Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte'],
         weekdaysShort: ['Diu', 'Dil', 'Dim', 'Dix', 'Dij', 'Div', 'Dis']
      },
      "en": {
         previousMonth: 'Previous Month',
         nextMonth: 'Next Month',
         months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
         weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
         weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      }
   }
}
FE$DateRenderer.prototype = new FE$BaseRenderer();

FE$DateRenderer.prototype.getType = function () {
   return 'date';
}
FE$DateRenderer.prototype.getValue = function () {
   var ret = this._input.value;
   if (ret === '') {
      return null;
   }
   return ret;
}

FE$DateRenderer.prototype.lock = function (doLock) {
   console.log('[FER_Date] Locking: ' + doLock);
   if (doLock) {
      this._input.setAttribute('disabled', true);
   } else {
      this._input.removeAttribute('disabled');
   }
}

FE$DateRenderer.prototype._parseDate = function (s) {

   // s is the result of `toString` method
   const parts = s.split('/');
   const day = parseInt(parts[0], 10);
   const month = parseInt(parts[1], 10) - 1;
   var year = parseInt(parts[2], 10);
   if (year < 50) {
      year += 2000;
   } else if (year > 50 && year < 100) {
      year += 1900;
   }
   return new Date(year, month, day);
}
FE$DateRenderer.prototype._calcDate = function (defDate) {
   if (!defDate) {
      return null;
   }
   var re = new RegExp('today\\s*([\\+-])\\s*([0-9]+)([dmyw])', 'gm');

   var ret = null;
   var m = null;
   var today = new Date();
   if (defDate == 'today') {
      ret = today;
   } else if ((m = re.exec(defDate))) {
      console.log('[FER_Date] Match with ' + defDate);
      var op = m[1];
      var sAmount = m[2];
      var amount = parseInt(sAmount, 10);
      var unit = m[3];

      if (unit == 'y') {
         ret = new Date(today.getFullYear() + (op == '+' ? amount : -amount), today.getMonth(), today.getDate());
      } else if (unit == 'm') {
         ret = new Date(today.getFullYear(), today.getMonth() + (op == '+' ? amount : -amount), today.getDate());
      } else if (unit == 'd') {
         ret = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (op == '+' ? amount : -amount));
      } else if (unit == 'w') {
         ret = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (op == '+' ? amount : -amount) * 7);
      }

   } else if (/[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{2,4}/.test(defDate)) {
      ret = this._parseDate(defDate);
   }

   return ret;
   /* if (def.minDate) {
      cfg.minDate = cfg.parse(def.minDate)
   }
   if (def.maxDate) {
      if (def.maxDate === 'today') {
         cfg.maxDate = new Date();
      } else {
         cfg.maxDate = cfg.parse(def.maxDate);
      }
   } */
}

FE$DateRenderer.prototype.translateTo = function (lang) {
   console.log('[FER_Date] Translating to ' + lang);

   // Mantaining the input causes problems on pick a date control...
   var newInput = this._input.cloneNode(true);
   var parent = this._input.parentNode;

   // insert input in the same place
   parent.insertBefore(newInput, this._input);
   parent.removeChild(this._input);
   this._input = newInput;

   var def = this.getDefinition();
   var langSvc = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.childNodes[0])
      }
      this._label.innerHTML = langSvc(def.label, lang);
   }
   if (def.placeholder) {
      this._input.setAttribute('placeholder', langSvc(def.placeholder, lang));
   }

   // Create control in translation...because it depends on the language
   var cfg = {
      field: this._input,
      firstDay: 1,
      toString: function (date, format) {
         // you should do formatting based on the passed format,
         // but we will just return 'D/M/YYYY' for simplicity
         const day = fe$utils.padleft('' + date.getDate(), '0', 2);
         const month = fe$utils.padleft('' + (date.getMonth() + 1), '0', 2);
         const year = date.getFullYear();
         return day + '/' + month + '/' + year; /* `${day}/${month}/${year}`; */
      },
      parse: this._parseDate


   };
   // Configure months
   if (lang in this._i18n) {
      cfg.i18n = this._i18n[lang];
   } else if (this.getDefaultLanguage() in this._i18n) {
      cfg.i18n = this._i18n[this.getDefaultLanguage()]
   } else {
      cfg.i18n = this._i18n['es']; // If no default...use es
   }
   if (def.minDate) {
      cfg.minDate = this._calcDate(def.minDate);
   }
   if (def.maxDate) {
      cfg.maxDate = this._calcDate(def.maxDate);
   }
   console.log('[FER] Calculated min and max date as ' + cfg.minDate + ' - ' + cfg.maxDate);
   if ('defaultDate' in def) {
      cfg.defaultDate = this._calcDate(def.defaultDate);
   } else {
      cfg.defaultDate = cfg.maxDate;
   }


   if (def.yearRange) {
      console.log('[FER] Year range set to: ' + def.yearRange);
      cfg.yearRange = def.yearRange;
   } else if (cfg.minDate && cfg.maxDate) {
      // Set date range according to dates
      console.log('[FER] NO YEAR RANGE??');
      var minYear = cfg.minDate.getFullYear();
      var maxYear = cfg.maxDate.getFullYear();
      cfg.yearRange = [minYear, maxYear];
   }
   console.log('[FER] Datepicker generated with ' + JSON.stringify(cfg));
   this._dpicker = new Pikaday(cfg);

}
FE$DateRenderer.prototype.render = function (where, lang) {
   console.log('[FER] Called string render')
   var def = this.getDefinition();

   // var container = this.getElement();
   if (def.label) {
      this._label = document.createElement('label')
      // this.label.appendChild(document.createTextNode(def.label))
      this._label.setAttribute('class', 'FE-controlR-label FE-dateR-label');
      where.appendChild(this._label);
   }

   this._input = document.createElement('input');


   this._input.setAttribute('name', def.name);
   this._input.setAttribute('type', 'text')
   this._input.setAttribute('class', 'FE-controlR-control FE-dateR-control')
   if(def.hasOwnProperty('tabIndex'))   
         this._input.setAttribute('tabIndex', def.tabIndex)
   
   where.appendChild(this._input);

   this.translateTo(lang);



}

FE$DateRenderer.prototype.lock = function (doLock) {
   console.log('[FER_DR] Locking: ' + doLock);
   if (doLock) {
      this._input.setAttribute('disabled', true);
   } else {
      this._input.removeAttribute('disabled');
   }
}

/* -------------------- STYLED CHOICE RENDERER ----------------------- */
function FE$StylizedChoiceRenderer() {
   this._label;
   this._input;
   this._placeholder;
   this._placeholder2;

   this._options;
   this._optionsContainer;

   this._optionHelper = null;

   this._isOpen = false;
   this._isLocked = false;

   // this._selectedIdx = -1;
   this._value = null;
}

FE$StylizedChoiceRenderer.prototype = new FE$BaseRenderer();

FE$StylizedChoiceRenderer.prototype.getType = function () {
   return 'choice';
}
FE$StylizedChoiceRenderer.prototype.getVariant = function () {
   return 'stycbx';
}
FE$StylizedChoiceRenderer.prototype.getValue = function () {
   return this._value;
}


FE$StylizedChoiceRenderer.prototype.onEvent = function (event, data, onControl) {
   console.log('[feSC] Detected event ' + event + ' on ' + onControl + '. REFRESHING');
   if (event == this.getProxy().Events.CHANGE) {
      this._refresh(this.getDefinition());
   }
}

FE$StylizedChoiceRenderer.prototype._getOptionText = function (index, lang) {
   return this._optionHelper.getOptionText(index, lang);
}

FE$StylizedChoiceRenderer.prototype.translateTo = function (lang) {
   console.log('[feSC] Translating to ' + lang);
   var def = this.getDefinition();
   var translate = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.firstChild)
      }
      this._label.innerHTML = translate(def.label, lang)
   }

   for (var i = this._optionsContainer.childNodes.length - 1; i >= 0; i--) {
      if (this._optionsContainer.childNodes[i] != this._placeholder2) {
         this._optionsContainer.removeChild(this._optionsContainer.childNodes[i]);
      }
   }

   var translation = this._optionHelper.getTranslationTo(lang);

   this._options = [];
   for (var i = 0; i < translation.length; i++) {
      console.log('[feSC] Creating option ' + i + ' with label ' + translation[i].label + ' and enabled: ' + translation[i].enabled, translation[i]);
      var option = document.createElement('div');
      var classList = 'FE-choiceR-option';

      option.setAttribute('value', translation[i].value)
      option.style.boxSizing = 'border-box';
      this._optionsContainer.appendChild(option);
      if (translation[i].enabled === false) {
         classList += ' disabled';
         option.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
      } else {
         option.addEventListener('click', this._onOptionSelected.bind(this, i))
      }

      if (this._value == translation[i].value) {
         classList += ' selected';
      }
      option.setAttribute('class', classList);
      this._options.push(option);
      option.innerHTML = translation[i].label;
   }

   this._updatePlaceholder(lang);
   if (def.placeholder2) {
      while (this._placeholder2.hasChildNodes()) {
         this._placeholder2.removeChild(this._placeholder2.firstChild);
      }
      this._placeholder2.innerHTML = translate(def.placeholder2, lang);
   }
}

FE$StylizedChoiceRenderer.prototype._updatePlaceholder = function (lang) {
   var def = this.getDefinition();
   var translate = this.getTranslator();
   while (this._placeholder.hasChildNodes()) {
      this._placeholder.removeChild(this._placeholder.firstChild);
   }
   var text = def.placeholder
   if (this._value) {
      text = this._optionHelper.getOptionTextForValue(this._value, lang);
   }
   console.log('[feSC] Translating placeholder ' + text + ' to ' + lang);
   if (text) {
      this._placeholder.innerHTML = translate(text, lang);
   } else
      this._placeholder.innerHTML = Constants.CHOOSE_AN_OPTION[lang]
}

FE$StylizedChoiceRenderer.prototype._onOptionSelected = function (index) {
   console.log('[feSC] Selected option: ' + index);

   var value = this._optionHelper.getOptionValueForIndex(index);
   if (this._value == value) {
      return; // Discard..no real change
   }
   // Remove previous selected
   for (var i = 0; i < this._options.length; i++) {
      fe$utils.removeClass('selected', this._options[i]);
   }
   this._value = value;
   fe$utils.addClass('selected', this._options[index]);
   fe$utils.addClass('option-selected', this._options[index].parentNode.parentNode);
   this._toggleCombo();
   this._updatePlaceholder(this.getLanguage());
   this.notifyChange();
}

FE$StylizedChoiceRenderer.prototype._toggleCombo = function (event) {
   if (this._isLocked) {
      return;
   }
   var def = this.getDefinition();
   console.log('[feSC] Toggling combo');
   this._isOpen = !this._isOpen;


   if (this._isOpen) {
      var height = 0;
      for (var i = 0; i < this._optionsContainer.childNodes.length; i++) {
         height += this._optionsContainer.childNodes[i].offsetHeight;
      }
      fe$utils.addClass('open', this.getElement());
      if ('maxHeight' in def && height > def.maxHeight) {
         height = def.maxHeight;
      }
      this._optionsContainer.style.height = height + 'px';
   } else {
      fe$utils.removeClass('open', this.getElement());
      this._optionsContainer.style.height = '0px';
   }
   if (event) { event.stopPropagation(); }
}


FE$StylizedChoiceRenderer.prototype._refresh = function (def) {
   console.log('[feSC] Reloading options');
   fe$utils.removeClass('option-selected', this.getElement());
   fe$utils.addClass('loading', this.getElement());
   this._value = null;
   var lang = this.getLanguage();
   this.lock(true);
   this._updatePlaceholder(lang);
   this._optionHelper.getOptions(lang, this._onOptionsReady.bind(this));
}

FE$StylizedChoiceRenderer.prototype.setValue = function (v) {
   console.log('[feSC] Setting stylized choice value to ' + v);
   var idx = this._optionHelper.getOptionIndexForValue(v);
   console.log('[feSC] Setting stylized choice value to ' + v + ' with index ' + idx);
   if (idx != null) {
      this._onOptionSelected(idx);
      this._value = v;
   }
}

FE$StylizedChoiceRenderer.prototype._onOptionsReady = function (data, isFull) {
   console.log('[feSCR] Obtained options for ' + this.getDefinition().name + ' and data: ' + JSON.stringify(data));
   for (var i = this._optionsContainer.childNodes.length - 1; i >= 0; i--) {
      if (this._optionsContainer.childNodes[i] != this?._placeholder2) {
         this._optionsContainer.removeChild(this._optionsContainer.childNodes[i]);
      }
   }
   fe$utils.removeClass('notFull', this._optionsContainer); // Mark if the data is full or not
   if (!isFull) {
      fe$utils.addClass('notFull', this._optionsContainer);
   }
   this._options = [];
   for (var i = 0; i < data.length; i++) {
      console.log('[feSC] Creating option ' + i + ' with label ' + data[i].label + ' and enabled: ' + data[i].enabled, data[i]);
      var option = document.createElement('div');
      var classList = 'FE-choiceR-option';

      option.setAttribute('value', data[i].value)
      option.style.boxSizing = 'border-box';
      this._optionsContainer.appendChild(option);
      if (data[i].enabled === false) {
         classList += ' disabled';
         option.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
      } else {
         option.addEventListener('click', this._onOptionSelected.bind(this, i))
      }
      option.setAttribute('class', classList);
      this._options.push(option);
      option.innerHTML = data[i].label;
   }
   this.lock(false);
   fe$utils.removeClass('loading', this.getElement());
   if (this._isOpen) { // if is open we need to recalculate the box so we close/open the object to force it
      this._toggleCombo();
      this._toggleCombo();
   }
}

FE$StylizedChoiceRenderer.prototype.render = function (where, lang) {
   var def = this.getDefinition();

   this._optionHelper = new FE$OptionHelper(this.getDefinition(), this.getProxy(), null, def.sort !== false);

   console.log('[FER] Called stylized choice render')
   // var container = this.getElement();



   var dependencies = this._optionHelper.getDependencies()
   for (var i = 0; i < dependencies.length; i++) {
      this.subscribeToChangesOn(dependencies[i]);
   }

   if (def.label) {
      this._label = document.createElement('label')

      this._label.setAttribute('class', 'FE-controlR-label FE-choiceR-label');
      where.appendChild(this._label);
   }

   this._input = document.createElement('div');
   this._input.setAttribute('class', 'FE-controlR-control FE-choiceR-control FE-choicestylized-control');
   this._input.addEventListener('click', this._toggleCombo.bind(this));

   this._placeholder = document.createElement('div');
   this._placeholder.setAttribute('class', 'FE-controlR-placeholder');
   this._input.appendChild(this._placeholder);

   var downBtn = document.createElement('div');
   downBtn.setAttribute('class', 'FE-controlR-handler');
   this._input.appendChild(downBtn);
   if(def.hasOwnProperty('tabIndex'))   
         this._input.setAttribute('tabIndex', def.tabIndex)
   
   where.appendChild(this._input);


   this._options = new Array();
   this._optionsContainer = document.createElement('div');
   if ('maxHeight' in def) {
      this._optionsContainer.style.overflowY = 'auto';
   } else {
      this._optionsContainer.style.overflowY = 'hidden';
   }
   this._optionsContainer.setAttribute('class', 'FE-choiceR-options');
   this._optionsContainer.style.boxSizing = 'border-box';

   if(def.placeholder2){
      this._placeholder2 = document.createElement('div');
      this._placeholder2.setAttribute('class', 'FE-controlR-placeholder2');
      this._optionsContainer.appendChild(this._placeholder2);
   }

   where.appendChild(this._optionsContainer);
   downBtn.addEventListener('click', this._close.bind(this));


   this.translateTo(lang);
   // this._updatePlaceholder(lang);
   // fe$utils.addClass('loading', this.getElement());
   // this._optionHelper.getOptions(lang, this._onOptionsReady.bind(this));
   this._refresh(this.getDefinition());
}

FE$StylizedChoiceRenderer.prototype._close = function () {
   console.log('Detected outer close');
   if (this._isOpen) {
      this._toggleCombo();
   }
}
FE$StylizedChoiceRenderer.prototype.lock = function (doLock) {
   console.log('[FER_Ltxt] Locking: ' + doLock);
   this._isLocked = doLock;
   if (doLock) {
      this._input.setAttribute('disabled', true);
   } else {
      this._input.removeAttribute('disabled');
   }
}

/* -------------------- STYLIZED RADIO RENDERER ----------------------- */
function FE$StylizedRadioChoiceRenderer() {
   this._label;
   this._rContainer;
   this._radios = new Array();
   this._radioLabels = new Array();
   this._radioDescs = new Array();
   this._selectedIdx = -1;
   this._optionHelper = null;
   this._value = null;
   this._lastOptions = null;
   this._initialized = false;
}

FE$StylizedRadioChoiceRenderer.prototype = new FE$BaseRenderer();

FE$StylizedRadioChoiceRenderer.prototype.getType = function () {
   return 'choice';
}

FE$StylizedRadioChoiceRenderer.prototype.getVariant = function () {
   return 'styrdio'
}
FE$StylizedRadioChoiceRenderer.prototype.getValue = function () {
   if (this._selectedIdx == -1) {
      return null;
   }
   console.log('[feSRC] Selected index: ' + this._selectedIdx);
   // var def = this.getDefinition();

   return this._value; // def.options[this._selectedIdx].value;
}

FE$StylizedRadioChoiceRenderer.prototype.setValueByIndex = function (idx) {
   console.log('[feSRC] Setting value of radio to index ' + idx + ' on ' + JSON.stringify(this.getDefinition()));
   if (idx != null) {
      this._selectedIdx = idx;
      this._value = this._lastOptions[idx].value;

      for (var i = 0; i < this._radios.length; i++) {
         fe$utils.removeClass('selected', this._radios[i]);
      }
      fe$utils.addClass('selected', this._radios[idx]);
   }
}

FE$StylizedRadioChoiceRenderer.prototype.setValue = function (v) {
   console.log('[feSRC] Setting value of radio to ' + v + ' on ' + JSON.stringify(this.getDefinition()));
   var idx = this._optionHelper.getOptionIndexForValue(v);
   this.setValueByIndex(idx);
}

FE$StylizedRadioChoiceRenderer.prototype.translateTo = function (lang) {
   console.log('[feSRC] Translating radio with current value ' + this._value);
   var def = this.getDefinition();
   var translate = this.getTranslator();

   var translation = this._optionHelper.getTranslationTo(lang);
   console.log('[feSRC] Number of radio labels: ' + this._radioLabels.length);
   this._lastOptions = translation;
   for (var i = 0; i < this._radioLabels.length; i++) {
      while (this._radioLabels[i].hasChildNodes()) {
         this._radioLabels[i].removeChild(this._radioLabels[i].firstChild)
      }
      console.log('[feSRC] Translating with option: ' + JSON.stringify(translation[i]));
      this._radioLabels[i].innerHTML = translate(translation[i].label, lang);

      while (this._radioDescs[i].hasChildNodes()) {
         this._radioDescs[i].removeChild(this._radioDescs[i].firstChild)
      }
      if (translation[i].description) {
         this._radioDescs[i].innerHTML = translate(translation[i].description, lang);
      }

   }

   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.firstChild)
      }
      this._label.innerHTML = translate(def.label, lang)
   }

   this.setValue(this._value);

}
FE$StylizedRadioChoiceRenderer.prototype.onEvent = function (event, data, onControl) {
   console.log('[feSRC] Detected event ' + event + ' on ' + onControl + ' for control ' + this.getDefinition().name + '. REFRESHING');
   if (event == this.getProxy().Events.CHANGE) {
      this._refresh(this.getDefinition());
   }
}

FE$StylizedRadioChoiceRenderer.prototype._onClick = function (selectedIdx) {
   if (this._lastOptions[selectedIdx].enabled === true ) {
      this.setValueByIndex(selectedIdx);
      console.log('[feSRC] Notifying change on radio click ' + this.getDefinition().name);
      this.notifyChange();
   }
   
}

FE$StylizedRadioChoiceRenderer.prototype._onKeyUp = function (selectedIdx) {
   if (this._lastOptions[selectedIdx].enabled === true && fe$utils.isSpaceBar(event)) {
      event.preventDefault();
      this.setValueByIndex(selectedIdx);
      console.log('[feSRC] Notifying change on radio Space ' + this.getDefinition().name);
      this.notifyChange();
   }

}
FE$StylizedRadioChoiceRenderer.prototype._onKeyDown = function () {
   if (fe$utils.isSpaceBar(event)) 
      event.preventDefault();
}

FE$StylizedRadioChoiceRenderer.prototype._onOptionsReady = function (data, isFull) {
   console.log('[feSRC] Options ready starts with index: ' + this._selectedIdx + ' and value: ' + this._value + ' on ' + this.getDefinition().name);
   this._lastOptions = data;
   while (this._rContainer.hasChildNodes()) {
      this._rContainer.removeChild(this._rContainer.firstChild);
   }
   var defValue = null;
   this._selectedIdx = -1;
   var def = this.getDefinition();
   if (this._value == null && 'defValue' in def) {
      defValue = def.defValue;
   }
   this._radios = new Array();
   this._radioLabels = new Array();
   //     for (var i=0; i < def.options.length; i++) {
   for (var i = 0; i < data.length; i++) {
      var rDiv = document.createElement('div');
      rDiv.addEventListener('click', this._onClick.bind(this, i));
      rDiv.addEventListener('keyup', this._onKeyUp.bind(this, i));
      rDiv.addEventListener('keydown', this._onKeyDown.bind(this, i));
      var classList = 'FE-choiceR-radiolayer';

      console.log('[feSRC] Option ' + data[i].value + ' has enabled set to ' + data[i].enabled);
      if (data[i].enabled === false) {

         classList += ' FE-disabled';
      }
      rDiv.setAttribute('class', classList)
      this._rContainer.appendChild(rDiv);

      var radio = document.createElement('div');

      radio.setAttribute('class', 'FE-controlR-control FE-styrdiochoiceR-control');
      radio.setAttribute('value', data[i].value);
      if (!data[i].enabled) {
         console.log('[feSRC] Detected disabled option: ' + JSON.stringify(data[i]));
      }
      if (this._value != null) {
         if (this._value == data[i].value && data[i].enabled) {
            this._selectedIdx = i;
         }
      } else if (!this._initialized && defValue != null) {
         if ((isNaN(defValue) && data[i].value == defValue) || i == defValue) {
            this._selectedIdx = i;
            this._value = data[i].value;
         }
      }
      radio.setAttribute('name', def.name);
      if(def.hasOwnProperty('tabIndex'))   
         radio.setAttribute('tabIndex', def.tabIndex)

      // radio.addEventListener('click', this._onClick.bind(this, i));
      rDiv.appendChild(radio);

      var rLabel = document.createElement('label');
      rDiv.appendChild(rLabel);
      rLabel.appendChild(document.createTextNode(data[i].label));
      this._radios.push(radio);
      this._radioLabels.push(rLabel);

      var rDesc = document.createElement('label');

      rDesc.setAttribute('class', 'FE-styrdiochoiceR-optDesc');
      this._radioDescs.push(rDesc);
      if (data[i].description) { // Append a description tag
         rDiv.appendChild(rDesc);
      }
   }
   this.lock(false);
   fe$utils.removeClass('loading', this.getElement());
   console.log('[feSRC] Options ready ends with index: ' + this._selectedIdx + ' and value: ' + this._value);
   // If predefined value, select it
   if (this._selectedIdx != -1) {
      this.setValueByIndex(this._selectedIdx);
   } else {
      console.log('[feSRC] No index selected for ' + this.getDefinition().name);
      this._value = null; // No index found for the value...reset
   }
   console.log('[feSRC] Notifying change on radio options ready ' + this.getDefinition().name);
   this._initialized = true;
   this.notifyChange();
}

FE$StylizedRadioChoiceRenderer.prototype._refresh = function (def) {
   console.log('[feSRC] Reloading options on ' + def.name);

   fe$utils.addClass('loading', this.getElement());
   // this._value = null;
   var lang = this.getLanguage();
   this.lock(true);
   // this._updatePlaceholder(lang);
   this._optionHelper.getOptions(lang, this._onOptionsReady.bind(this));
}


FE$StylizedRadioChoiceRenderer.prototype.render = function (where, lang) {
   console.log('[feSRC] Called string render')
   var def = this.getDefinition();
   if (def.label) {
      this._label = document.createElement('label')
      this._label.appendChild(document.createTextNode(def.label))
      this._label.setAttribute('class', 'FE-controlR-label FE-choiceR-label');
      where.appendChild(this._label);
   }

   this._rContainer = document.createElement('div');
   this._rContainer.setAttribute('class', 'FE-choiceR-radios');
   where.appendChild(this._rContainer);

   this._optionHelper = new FE$OptionHelper(this.getDefinition(), this.getProxy(), null, def.sort !== false);
   var dependencies = this._optionHelper.getDependencies();
   console.log('[feSRC] Obtained dependencies for stylized radio: ' + dependencies);
   for (var i = 0; i < dependencies.length; i++) {
      this.subscribeToChangesOn(dependencies[i]);
   }
   this.translateTo(lang);

   this._refresh(this.getDefinition());

}

FE$StylizedRadioChoiceRenderer.prototype.lock = function (doLock) {
   console.log('[FER_Ltxt] Locking: ' + doLock);
   for (var i = 0; i < this._radios.length; i++) {
      if (doLock) {
         this._radios[i].setAttribute('disabled', true);
      } else {
         this._radios[i].removeAttribute('disabled');
      }
   }
}

/* -------------------- STYLIZED CHECKBOX RENDERER ----------------------- */
function FE$StylizedCheckRenderer() {
   this._langSvc = null;
   this._input = null;
   this._label = null;
   this._checked = false;
}
FE$StylizedCheckRenderer.prototype = new FE$BaseRenderer();

FE$StylizedCheckRenderer.prototype.getType = function () {
   return 'check';
}
FE$StylizedCheckRenderer.prototype.getVariant = function () {
   return 'stychk';
}

FE$StylizedCheckRenderer.prototype.getValue = function () {
   var def = this.getDefinition();
   var ret = this._checked ? (def.value ? def.value : 'true') : null;
   console.log('[feSChk] Checked? ' + this._checked + '. Returning: ' + ret);

   return ret;
}

FE$StylizedCheckRenderer.prototype._onKeyUp = function () {
   if (fe$utils.isSpaceBar(event)){
      event.preventDefault();
      this._onClick();
   }
}

FE$StylizedCheckRenderer.prototype._onKeyDown = function () {
   if (fe$utils.isSpaceBar(event))
      event.preventDefault();
}

FE$StylizedCheckRenderer.prototype._onClick = function () {
   console.log('Clicked stylized check renderer');
   this._checked = !this._checked;
   if (this._checked) {
      fe$utils.addClass('selected', this._input);
   } else {
      fe$utils.removeClass('selected', this._input);
   }
   this.notifyChange();
}

FE$StylizedCheckRenderer.prototype.translateTo = function (lang) {
   var def = this.getDefinition();
   var langSvc = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.childNodes[0])
      }
      this._label.innerHTML = langSvc(def.label, lang);
   }
   if (def.placeholder) {
      this._input.setAttribute('placeholder', langSvc(def.placeholder, lang));
   }
}
FE$StylizedCheckRenderer.prototype.render = function (where, lang) {
   console.log('[FER] Called string render');

   var def = this.getDefinition();


   this._input = document.createElement('div');

   this._input.setAttribute('name', def.name);
   this._input.setAttribute('value', def.value ? def.value : 'true');
   this._input.setAttribute('class', 'FE-controlR-control FE-stychkR-control')
   this._input.addEventListener('click', this._onClick.bind(this));
   this._input.addEventListener('keyup', this._onKeyUp.bind(this));
   this._input.addEventListener('keydown', this._onKeyDown.bind(this));
   if(def.hasOwnProperty('tabIndex'))   
         this._input.setAttribute('tabIndex', def.tabIndex)
   
   where.appendChild(this._input);

   if (def.label) {
      this._label = document.createElement('label')
      // this.label.appendChild(document.createTextNode(def.label))
      this._label.setAttribute('class', 'FE-controlR-label FE-stychkR-label');
      where.appendChild(this._label);
   }
   this.translateTo(lang);

}

FE$StylizedCheckRenderer.prototype.lock = function (doLock) {
   console.log('[FER_Check] Locking: ' + doLock);
   if (doLock) {
      this._input.setAttribute('disabled', true);
   } else {
      this._input.removeAttribute('disabled');
   }
}

/* -------------------- IMAGE RENDERER ----------------------- */
function FE$NativeImageRenderer() {
   this._image;
}

FE$NativeImageRenderer.prototype = new FE$BaseRenderer();

FE$NativeImageRenderer.prototype.getType = function () {
   return 'image';
}

FE$NativeImageRenderer.prototype.getVariant = function () {
   return 'native'
}
FE$NativeImageRenderer.prototype.isValueControl = function () {
   return false;
}
FE$NativeImageRenderer.prototype.translateTo = function (lang) {
   console.log('Translating image');
   var def = this.getDefinition();
   var translate = this.getTranslator();
   if (def.alt) {
      this._image.setAttribute('title', translate(def.alt, lang));
   }
}
FE$NativeImageRenderer.prototype.render = function (where, lang) {
   console.log('[FER] Called string render')
   var def = this.getDefinition();
   this._image = document.createElement('img');
   this._image.setAttribute('class', 'FE-controlR-image FE-nImageR-image')

   this._image.setAttribute('src', def.url);
   where.appendChild(this._image);

   if (def.alt) {
      this.translateTo(lang);
   }
   if (def.height && def.width) {
      throw new FEngineException('Not allowed to specify both width and height')
   }
   if (def.height) {
      this._image.style.height = def.height;
   }
   if (def.width) {
      this._image.style.width = def.width;
   }

}

/* -------------------- AUTOCOMPLETE CHOICE RENDERER ----------------------- */
function FE$AutoCompleteChoiceRenderer() {
   this._label;
   this._input;
   this._inputCont;

   this._placeholder;
   this._placeholder2;
   this._isFreeOption;

   this._options;
   this._optionsContainer;

   this._optionHelper = null;

   this._isOpen = false;
   this._isLocked = false;

   this._value = null;

   this._lastTextValue = null;
   this._tabIndex = 0;
}

FE$AutoCompleteChoiceRenderer.prototype = new FE$BaseRenderer();

FE$AutoCompleteChoiceRenderer.prototype.getType = function () {
   return 'choice';
}
FE$AutoCompleteChoiceRenderer.prototype.getVariant = function () {
   return 'autocomplete';
}
FE$AutoCompleteChoiceRenderer.prototype.getValue = function () {
   var ret = {}
   if (this._value) {
      ret[''] = this._value;
   }
   ret['text'] = this._input.value
   return ret;

}

FE$AutoCompleteChoiceRenderer.prototype.setValue = function (value, prop) {
   console.log('[feAcC] Setting value on autocomplete ' + this.getDefinition().name + ' for property ' + prop + ' to ' + value);
   if (prop == this.getDefinition().name) {
      console.log('[feAcC] Setting value to ' + value);
      this._value = value;
   }
   
   this._input.classList.remove("floating-label-top");
   if (prop.indexOf('.text') != -1) {
      console.log('[feAcC] Setting text to ' + value);
      this._input.value = value;
      //FIXME! : this is template dependant, is only need in form02 
      this._input.classList.add("floating-label-top");
      fe$utils.addClass('notEmpty', this.getElement());
   }

}

FE$AutoCompleteChoiceRenderer.prototype.onEvent = function (event, data, onControl) {
   console.log('[feAcC] Detected event ' + event + ' on ' + onControl + '. REFRESHING');
   if (event == this.getProxy().Events.CHANGE) {
      this._refresh(this.getDefinition());
   }
}

FE$AutoCompleteChoiceRenderer.prototype._getOptionText = function (index, lang) {
   console.log('[feAcC] get Option Text For Value ' + this._value + ' and lang ' + lang + '. REFRESHING');
   return this._optionHelper.getOptionTextForValue(this._value, lang);
}


FE$AutoCompleteChoiceRenderer.prototype.translateTo = function (lang) {
   console.log('[feAcC] Translating to ' + lang);
 
   var def = this.getDefinition();
   var translate = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.firstChild)
      }
      this._label.innerHTML = translate(def.label, lang)
   }


   if (this._value) {
      this._input.value = this._optionHelper.getOptionTextForValue(this._value, lang);
      this._lastTextValue = this._input.value;
   }

   this._updatePlaceholder(1)
   this._optionHelper.getOptions(this.getLanguage(), this._onOptionsReady.bind(this, false));
}

/**
* @param {(1|2)} placeholder
*/
FE$AutoCompleteChoiceRenderer.prototype._updatePlaceholder = function(placeholder) {
   let def = this.getDefinition()
   let translate = this.getTranslator()
   let lang = this.getLanguage()

   let placeholderName = 'placeholder' + (placeholder==1 ? '' : '2')
   let text = def[placeholderName] ? 
               translate(def[placeholderName], lang) : 
               placeholder==1 ? '' :
               this._options.length>0 ?
                  Constants.CHOOSE_AN_OPTION[lang] : Constants.NO_OPTIONS_AVAILABLE[lang]
   
   console.log('[feAcC] Setting ' + placeholderName + ' to [' + text + ']')
   placeholderName = '_'+placeholderName
   while (this[placeholderName].hasChildNodes()) {
      this[placeholderName].removeChild(this[placeholderName].firstChild);
   }
   this[placeholderName].appendChild(document.createTextNode(text))
} 

FE$AutoCompleteChoiceRenderer.prototype._onOptionSelected = function (index) {
   console.log('[feAcC] Selected option: ' + index);
   var value = this._optionHelper.getOptionValueForIndex(index);

   if (!value || value == this._value) {
      return; // Discard..no real change
   }
   for (var i = 0; i < this._options.length; i++) {
      // Remove previous selected
      fe$utils.removeClass('selected', this._options[i]);
   }
   fe$utils.addClass('notEmpty', this.getElement());
   fe$utils.addClass('FE-state-filledIn', this.getElement());
   this._value = value;
   fe$utils.addClass('selected', this._options[index]);
   var text = this._optionHelper.getOptionTextForValue(this._value, this.getLanguage());

   this.notifyChange();
   console.log('[feAcC] Set value to ' + text);
   this._input.value = text;
   this._lastTextValue = this._input.value;
   this._open(false);
}

FE$AutoCompleteChoiceRenderer.prototype._open = function (doOpen) {
   console.log('[feAcC] Toggling combo');
   if (this._isLocked) 
      return;
      
   this._isOpen = doOpen;
   fe$utils.removeClass('open', this.getElement());
   fe$utils.removeClass('FE-state-focus', this.getElement());
   
   if(doOpen==='blur') {
      doOpen = Boolean(document.activeElement.tabIndex >= this._tabIndex && document.activeElement.tabIndex <= this._tabIndex + this._options.length);
   }
   
   if(doOpen) {
      this._updatePlaceholder(2)
      this._setOpenHeight();
   }else{
      fe$utils.addClass('select-hide', this._optionsContainer);
      //e.currentTarget.classList.add('select-hide');
      this._optionsContainer.style.height = '0px';
      this._clearOptions();
   }
}

FE$AutoCompleteChoiceRenderer.prototype._refresh = function (def, open) {
   console.log('[feAcC] Reloading options');
   fe$utils.addClass('loading', this.getElement());
   /* this._value = null;
   this._input.value = ''; */
   fe$utils.removeClass('notFull', this._optionsContainer); // Mark if the data is full or not
   fe$utils.removeClass('notEmpty', this.getElement());
   var lang = this.getLanguage();
   this.lock(true);
   // this._updatePlaceholder(lang);
   this._optionHelper.getOptions(lang, this._onOptionsReady.bind(this, open));
}

FE$AutoCompleteChoiceRenderer.prototype._setOpenHeight = function () {
   fe$utils.removeClass('select-hide', this._optionsContainer);
   var height = 0;
   var maxHeight = this.getDefinition()?.maxHeight;
   this._optionsContainer.childNodes.forEach(option => height += Math.ceil(option.offsetHeight));
   
   if ( height > maxHeight) 
      height = maxHeight
   
   this._optionsContainer.style.height = height + 'px';

   if(height>0) {
      fe$utils.addClass('open', this.getElement());
      fe$utils.addClass('FE-state-focus', this.getElement());
   }else
      fe$utils.addClass('select-hide', this._optionsContainer);
}

FE$AutoCompleteChoiceRenderer.prototype._clearOptions = function () {
   fe$utils.removeClass('notFull', this._optionsContainer); // Mark if the data is full or not
   for (var i = this._optionsContainer.childNodes.length - 1; i >= 0; i--) {
      if (this._optionsContainer.childNodes[i] != this._placeholder2) {
         this._optionsContainer.removeChild(this._optionsContainer.childNodes[i]);
      }
   }
   this._options = [];
}

FE$AutoCompleteChoiceRenderer.prototype._onOptionsReady = function (open, data, isFull) {
   this._clearOptions();
   fe$utils.removeClass('notFull', this._optionsContainer); // Mark if the data is full or not
   let valueFoundIndex = -1
   let textboxValue = '';
   if (this._input.value) { // Add only if there is a input value (it can belong to an old request...)
      console.log('[feAcC] Obtained options for ' + this.getDefinition().name + ' and data: ' + JSON.stringify(data));

      if (!isFull) {
         fe$utils.addClass('notFull', this._optionsContainer);
      }
      textboxValue = this._input.value.toLowerCase()
      
      valueFoundIndex = data.findIndex((dataOption, index) =>{        
         let optionLabel = dataOption.label.toLowerCase()
         console.log('[feAcC] Creating option ' + index);
         if(optionLabel.includes(textboxValue)) {
            let isValueAnOption = (this._value === dataOption.value || textboxValue === optionLabel)
                       
            let option = document.createElement('div');
            option.setAttribute('value', dataOption.value)
            if(this._tabIndex)   
               option.setAttribute('tabIndex', this._tabIndex+index+1)
            option.setAttribute('class', 'FE-choiceR-option')
            option.style.boxSizing = 'border-box'
            option.addEventListener('click', this._onOptionSelected.bind(this, index))
            option.addEventListener('keyup', this._onOptionKeyUp.bind(this, index))
            option.addEventListener('keydown', this._onOptionKeyDown.bind(this, index))
            if(index == data.length-1)
               option.addEventListener('focusout', this._open.bind(this, 'blur'))

            let textNode = document.createTextNode(dataOption.label)
            option.appendChild(textNode)

            this._optionsContainer.appendChild(option);
            this._options.push(option);
            if(isValueAnOption){
               this._onOptionSelected(index)
               return true;
            }
         }
      })
   }
   
   this.lock(false);
   fe$utils.removeClass('loading', this.getElement());
   if(valueFoundIndex == -1){
      this._open(textboxValue.length > 2)
   }
}

FE$AutoCompleteChoiceRenderer.prototype._onOptionKeyDown = function (index) {
      event.preventDefault();
}

FE$AutoCompleteChoiceRenderer.prototype._onOptionKeyUp = function (index) {
   const pressedKey = event;
   if (fe$utils.isSpaceBar(pressedKey)  || pressedKey.keyCode == Constants.KEY_CODES.ENTER) {
      pressedKey.preventDefault();
      this._onOptionSelected(index);

   }else if(pressedKey.keyCode == Constants.KEY_CODES.UP) {
      pressedKey.preventDefault(); 
      if(--index <= 0) 
         index = 1
      document.querySelector("[tabindex='"+(this._tabIndex+index+1)+"']").focus();

   }else if(pressedKey.keyCode == Constants.KEY_CODES.DOWN) {
      pressedKey.preventDefault();
      if((++index) <= this._options.length)
         document.querySelector("[tabindex='"+(this._tabIndex+index+1)+"']").focus();
   }
}

FE$AutoCompleteChoiceRenderer.prototype._onKeyUp = function (index) {
   const pressedKey = event;
   if(pressedKey.keyCode == Constants.KEY_CODES.DOWN) {
      document.querySelector("[tabindex='"+(this._tabIndex+1)+"']").focus();
   }
}

FE$AutoCompleteChoiceRenderer.prototype._onInputChange = function (e) {
   if(this._lastTextValue == this._input.value){
      console.log('[feAcC] Ignoring last value: ' + this._lastTextValue)
      return;
   }else if (this._value) {
      this._value = null;
      this.notifyChange();
   }
   
   let value = this._input.value.trimStart() //evitamos que sean solo espacios
   this._lastTextValue = this._input.value = value 
   fe$utils.removeClass('notEmpty', this.getElement());
   
   if(this._isFreeOption)
      this._value = value
    
   if(value?.length > 0) 
      fe$utils.addClass('notEmpty', this.getElement());

   //AMH FIX xxx: solo buscar con 3 o mas caracteres       
   if (value?.length > 2) {
      fe$utils.addClass('loading', this.getElement());
      this._optionHelper.getOptions(this.getLanguage(), this._onOptionsReady.bind(this, true));
   } else {
      console.log('[feAcC] Clearing options for ' + value)
      this._open(false);
   }
}

FE$AutoCompleteChoiceRenderer.prototype._getText = function () {
   return this._input.value;
}

FE$AutoCompleteChoiceRenderer.prototype._onFocus = function () {
   //AMH FIX xxx: solo buscar con 3 o mas caracteres    
   if (this._input.value.length > 2) 
      this._open(true);

   fe$utils.addClass('FE-state-focus', this.getElement());
}

FE$AutoCompleteChoiceRenderer.prototype._onBlur = function () {
   setTimeout(this._open.bind(this, 'blur'), 500);
   if(!this._value)
      fe$utils.removeClass('FE-state-focus', this.getElement());
}

FE$AutoCompleteChoiceRenderer.prototype.render = function (where, lang) {
   var def = this.getDefinition();
   this._optionHelper = new FE$OptionHelper(this.getDefinition(), this.getProxy(), this._getText.bind(this), def.sort !== false);

   console.log('[feAcC] Called stylized choice render')
   // var container = this.getElement();

   var dependencies = this._optionHelper.getDependencies()
   for (var i = 0; i < dependencies.length; i++) {
      this.subscribeToChangesOn(dependencies[i]);
   }

   if (def.label) {
      this._label = document.createElement('label')

      this._label.setAttribute('class', 'FE-controlR-label FE-choiceR-label FE-choiceautocompleteR-label');
      where.appendChild(this._label);
   }

   this._isFreeOption = Boolean(def?.isFreeOption)

   this._inputCont = document.createElement('div');
   this._inputCont.setAttribute('class', 'FE-autocomplete-inputWrapper');
   where.appendChild(this._inputCont);

   var handler = document.createElement('div');
   handler.setAttribute('class', 'handler');
   this._inputCont.appendChild(handler);

   this._input = document.createElement('input');
   this._input.addEventListener('focus', this._onFocus.bind(this));
   this._input.addEventListener('blur', this._onBlur.bind(this));
   this._input.addEventListener('input', this._onInputChange.bind(this));
   this._input.addEventListener('keyup', this._onKeyUp.bind(this));
   
   this._input.setAttribute('class', 'FE-controlR-control FE-choiceR-control FE-autocomplete-control');

   if(def.hasOwnProperty('tabIndex')) {
      this._input.setAttribute('tabIndex', def.tabIndex)
      this._tabIndex = def.tabIndex;
   }
   
   this._inputCont.appendChild(this._input);

   this._placeholder = document.createElement('div');
   this._placeholder.setAttribute('class', 'FE-controlR-placeholder');
   this._inputCont.appendChild(this._placeholder);

   /* var downBtn = document.createElement('div');
   downBtn.setAttribute('class', 'FE-controlR-handler');
   this._input.appendChild(downBtn); */

   this._options = new Array();
   this._optionsContainer = document.createElement('div');
   this._optionsContainer.setAttribute('class', 'FE-choiceR-options');
   this._optionsContainer.style.boxSizing = 'border-box';
   if ('maxHeight' in def) {
      this._optionsContainer.style.overflowY = 'auto';
   } else {
      this._optionsContainer.style.overflowY = 'hidden';
   }
   this._placeholder2 = document.createElement('div');
   this._placeholder2.setAttribute('class', 'FE-controlR-placeholder2');
   this._optionsContainer.appendChild(this._placeholder2);

   where.appendChild(this._optionsContainer);
   // document.body.addEventListener('click', this._close.bind(this));


   this.translateTo(lang);
   // this._updatePlaceholder(lang);

}

FE$AutoCompleteChoiceRenderer.prototype.lock = function (doLock) {
   console.log('[feAcC] Locking: ' + doLock);
   this._isLocked = doLock;
   if (doLock) {
      this._input.setAttribute('disabled', true);
   } else {
      this._input.removeAttribute('disabled');
   }
}

/* -------------------- STYLIZED CHECKBOX RENDERER ----------------------- */
function FE$BoxedCheckRenderer() {
   this._langSvc = null;
   this._box = null;
   this._bg = null;
   this._label = null;
   this._checked = false;
   this._locked = false;

   this._mainColor = '#E36144';

}
FE$BoxedCheckRenderer.prototype = new FE$BaseRenderer();

FE$BoxedCheckRenderer.prototype.getType = function () {
   return 'check';
}
FE$BoxedCheckRenderer.prototype.getVariant = function () {
   return 'boxed';
}

FE$BoxedCheckRenderer.prototype.getValue = function () {
   var def = this.getDefinition();
   var ret = this._checked ? (def.value ? def.value : 'true') : ('unvalue' in def ? def.unvalue : null);
   console.log('[feBChk] Checked? ' + this._checked + '. Returning: ' + ret);

   return ret;
}

FE$BoxedCheckRenderer.prototype._onClick = function () {
   console.log('Clicked stylized check renderer');
   if (this._locked) {
      return;
   }
   this._checked = !this._checked;
   if (this._checked) {
      fe$utils.addClass('selected', this._box);
   } else {
      fe$utils.removeClass('selected', this._box);
   }
}
FE$BoxedCheckRenderer.prototype._onKeyUp = function () {
   console.log('KeyUp stylized check renderer');
   if (this._locked || fe$utils.isSpaceBar(event)) 
      return;
  
   this._checked = !this._checked;
   if (this._checked) {
      fe$utils.addClass('selected', this._box);
   } else {
      fe$utils.removeClass('selected', this._box);
   }
}
FE$BoxedCheckRenderer.prototype._onKeyDown = function () {
   if (fe$utils.isSpaceBar(event)) 
      event.preventDefault();
}
FE$BoxedCheckRenderer.prototype.translateTo = function (lang) {
   var def = this.getDefinition();
   var langSvc = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.childNodes[0])
      }
      this._label.innerHTML = langSvc(def.label, lang);
   }
   if (def.placeholder) {
      this._input.setAttribute('placeholder', langSvc(def.placeholder, lang));
   }
}
FE$BoxedCheckRenderer.prototype.render = function (where, lang) {
   console.log('[FER] Called string render');

   var def = this.getDefinition();
   if (def.color) {
      // Check valid
      if (!/#[0-9a-f]{3,7}/i.test(def.color) && !/rgba?\([0-9]{1,3}(,[ ]*[0-9]{1,3})+\)/i.test(def.color)) {
         throw new FEngineException('Wrong color definition for boxed check: ' + def.color);
      }
      this._mainColor = def.color;
   }



   this._box = document.createElement('div');

   this._box.setAttribute('name', def.name);
   this._box.setAttribute('value', def.value ? def.value : 'true');
   this._box.setAttribute('class', 'FE-controlR-control FE-boxchkR-control' + (def.height ? ' fixedHeight' : ''))
   if(def.hasOwnProperty('tabIndex'))   
      this._box.setAttribute('tabIndex', def.tabIndex)
   
   this._box.addEventListener('click', this._onClick.bind(this));
   this._box.addEventListener('keyup', this._onKeyUp.bind(this));
   this._box.addEventListener('keydown', this._onKeyDown.bind(this));
   
   this._box.style.borderColor = this._mainColor;
   this._box.style.color = this._mainColor;
   if (def.height) {
      this._box.style.height = def.height;
   }

   where.appendChild(this._box);

   if (def.label) {
      this._label = document.createElement('label')
      // this.label.appendChild(document.createTextNode(def.label))
      this._label.setAttribute('class', 'FE-controlR-label FE-boxchkR-label');
      // this._label.style.color = def.color;
      this._box.appendChild(this._label);
   }
   this._bg = document.createElement('div');
   this._bg.setAttribute('class', 'FE-controlR-bg FE-boxchkR-bg');
   this._bg.style.backgroundColor = this._mainColor;
   this._box.appendChild(this._bg);

   this.translateTo(lang);

}

FE$BoxedCheckRenderer.prototype.lock = function (doLock) {
   console.log('[FER_Check] Locking: ' + doLock);
   this._locked = doLock;
   if (doLock) {
      this._box.setAttribute('disabled', true);
   } else {
      this._box.removeAttribute('disabled');
   }
}

/* -------------------- STYLIZED MULTI CHOICE ----------------------- */
function FE$MultiChoiceRenderer() {
   this._langSvc = null;
   this._label = null;
   this._isOpen = false;
   this._locked = false;
   this._options = [];
   this._opSelection = {};
   this._separator = ',';
   this._checkAll = 'checkAll';
   this._placeholder = null;
   this._placeholder2 = null;
   this._tabIndex = null;
}

FE$MultiChoiceRenderer.prototype = new FE$BaseRenderer();

FE$MultiChoiceRenderer.prototype.isCheckAll = function (value) { return this._checkAll === value; };

FE$MultiChoiceRenderer.prototype.getType = function () {
   return 'multichoice';
}
FE$MultiChoiceRenderer.prototype.getVariant = function () {
   return 'raw';
}

FE$MultiChoiceRenderer.prototype.getValue = function () {
   var ret = { array: new Array(), '': '' };

   for (var v in this._opSelection) {
      if (this._opSelection[v] === true && !this.isCheckAll(v)) {
         if (ret[''].length > 0) {
            ret[''] += this._separator;
         }
         ret[''] += v;
         ret.array.push({ "value": v });
      }
   }
   return ret;
}

FE$MultiChoiceRenderer.prototype.onEvent = function (event, data, onControl) {
   console.log('[feSC] Detected event ' + event + ' on ' + onControl);
   if (event == this.getProxy().Events.CHANGE) {
      this._refresh(this.getDefinition());
   }
}

FE$MultiChoiceRenderer.prototype._getOptionText = function (index, lang) {
   return this._optionHelper.getOptionText(index, lang);
}

FE$MultiChoiceRenderer.prototype.translateTo = function (lang) {
   console.log('[feSC] Translating to ' + lang);
   var def = this.getDefinition();
   var translate = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.firstChild)
      }
      this._label.innerHTML = translate(def.label, lang)
   }

   var translation = [{ "label": Constants.CHECKBOX_CHECKALL[lang], "value": "checkAll", "enabled": true }].concat(this._optionHelper.getTranslationTo(lang));

   for (var i = 0; i < this._options.length; i++) {
      fe$utils.removeClass('selected', this._options[i]);
      while (this._options[i].childNodes.length > 1) {
         this._options[i].removeChild(this._options[i].lastChild);
      }
      if (this._value == translation[i].value) {
         fe$utils.addClass('selected', this._options[i]);
      }
      this._options[i].appendChild(document.createTextNode(translation[i].label));
   }

   this._updatePlaceholder(lang);   
}

FE$MultiChoiceRenderer.prototype._updatePlaceholder = function (lang) {
   var def = this.getDefinition();
   var translate = this.getTranslator();
   while (this._placeholder?.hasChildNodes()) {
      this._placeholder.removeChild(this._placeholder.firstChild);
   }
   while (this._placeholder2?.hasChildNodes()) {
      this._placeholder2.removeChild(this._placeholder2.firstChild);
   }
   // Count number of options selected
   var count = 0;
   for (var v in this._opSelection)
      this._opSelection[v] === true && 
      !this.isCheckAll(v) &&
      count++;

   //update check all
   if(this._options.length>0){
      let isSelected = this._options.length-1 === count
      this._opSelection[this._checkAll] = isSelected
      this._options[0].childNodes[0].classList[ isSelected ? 'add' : 'remove']('selected') //asumimos que checkall siempre es index0 por el render
   }
   /* si checkall dejase de ser el index0 habría que hacer esto.
   this._options.forEach(option => {  
      if(this.isCheckAll(option.getAttribute('value'))
         option.childNodes[0].classList[ isSelected ? 'add' : 'remove']('selected')
   });
   */
   
   //Translate placeholder1
   var text = '';
   
   if(!def.placeholder && count === 0)
       text = Constants.CHOOSE_AN_OPTION[lang]

   if(def.placeholder) 
       text = translate(def.placeholder, lang) + ' ';
   if(count)
       text += '(' + count + ')'
   console.log('[feSC] Translating placeholder ' + text + ' to ' + lang);
   this._placeholder.appendChild(document.createTextNode(text));

   //Translate placeholder2
   if(def.placeholder2) {
      console.log('[feSC] Translating placeholder2 ' + def.placeholder2 + ' to ' + lang);
      this._placeholder2.appendChild(document.createTextNode(translate(def.placeholder2, lang))); 
   }
}

FE$MultiChoiceRenderer.prototype._toggleCombo = function (event) {
   if (this._isLocked) {
      return;
   }
   console.log('[feSC] Toggling combo');
   this._isOpen = !this._isOpen;

   if (this._isOpen) {
      var height = 0;
      for (var i = 0; i < this._optionsContainer.childNodes.length; i++) {
         height += this._optionsContainer.childNodes[i].offsetHeight;
      }
      fe$utils.addClass('open', this.getElement());
      this._optionsContainer.style.height = height + 'px';
      this._optionsContainer.style.display = 'inline-table'; //FIXing DJF
   } else {
      fe$utils.removeClass('open', this.getElement());
      this._optionsContainer.style.height = '0px';
      this._optionsContainer.style.display = 'none'; //FIXing DJF
   }
   if (event) { event.stopPropagation(); }
}
FE$MultiChoiceRenderer.prototype._onKeyDown = function () {
   if (fe$utils.isSpaceBar(event)) 
      event.preventDefault();
}
FE$MultiChoiceRenderer.prototype._onKeyUp = function () {
   if (fe$utils.isSpaceBar(event)) 
      this._toggleCombo(null)
}
FE$MultiChoiceRenderer.prototype._refresh = function (def) {
   console.log('[feSC] Reloading options');
   fe$utils.addClass('loading', this.getElement());
   this._value = null;
   var lang = this.getLanguage();
   this.lock(true);
   this._updatePlaceholder(lang);
   this._optionHelper.getOptions(lang, this._onOptionsReady.bind(this));
}

FE$MultiChoiceRenderer.prototype._onOptionChange = function (optionValue, optionCheck) {
   let newValue = !this._opSelection[optionValue]
   console.log('[feMC] Option changed. Value: ' + optionValue + ', checked? ' + newValue + '(' + optionCheck + ')');
   
   if (this.isCheckAll(optionValue))
      this._options.forEach(option => {  
         this._opSelection[option.getAttribute('value')] = newValue
         option.childNodes[0].classList[ newValue ? 'add' : 'remove']('selected')
      });
   else{
      optionCheck.classList.toggle('selected')
      this._opSelection[optionValue] = newValue
   }

   // Update placeholder
   this._updatePlaceholder(this.getLanguage());

   this.notifyChange();
}
FE$MultiChoiceRenderer.prototype._onOptionKeyUp = function (optionValue, optionCheck) {
   if (fe$utils.isSpaceBar(event)) {
      event.preventDefault();
      this._onOptionChange(optionValue, optionCheck);
   }
   
}

FE$MultiChoiceRenderer.prototype._onOptionKeyDown = function () {
   if (fe$utils.isSpaceBar(event)) {
      event.preventDefault();      
   }
}

FE$MultiChoiceRenderer.prototype._onOptionsReady = function (data, isFull) {
   console.log('[feSCR] Obtained options for ' + this.getDefinition().name + ' and data: ' + JSON.stringify(data));
   for (var i = this._optionsContainer.childNodes.length - 1; i >= 0; i--) {
      if (this._optionsContainer.childNodes[i] != this._placeholder2) {
         this._optionsContainer.removeChild(this._optionsContainer.childNodes[i]);
      }
   }
   fe$utils.removeClass('notFull', this._optionsContainer); // Mark if the data is full or not
   if (!isFull) {
      fe$utils.addClass('notFull', this._optionsContainer);
   }
   this._options = [];
   this._opSelection = {};
   //data.unshift({ 'value': this._checkAll, 'label': 'Marcar todos' }); //si no se pone en data puede fallar? por index en container.
   data.unshift({ 'value': this._checkAll, 'label': Constants.CHECKBOX_CHECKALL[this.getLanguage()] });
   for (var i = 0; i < data.length; i++) {
      console.log('[feSC] Creating option ' + i);
      var option = document.createElement('div');
      option.setAttribute('class', 'FE-multichoiceR-option');
      option.setAttribute('value', data[i].value)
      option.style.boxSizing = 'border-box';
      this._opSelection[data[i].value] = false;
      this._optionsContainer.appendChild(option);

      var check = document.createElement('div');
      check.setAttribute('class', 'FE-multichoiceR-check');
      // check.setAttribute('type', 'checkbox');
      option.addEventListener('click', this._onOptionChange.bind(this, data[i].value, check));
      option.addEventListener('keyup', this._onOptionKeyUp.bind(this, data[i].value, check));
      option.addEventListener('keydown', this._onOptionKeyDown.bind(this, data[i].value, check));
      if(this._tabIndex)
         option.setAttribute('tabIndex', this._tabIndex+i+1);
      option.appendChild(check);
      var textNode = document.createTextNode(data[i].label);
      option.appendChild(textNode);
      this._options.push(option);
      //FIXing DJF
      this._optionsContainer.style.display = 'none';
   }
   this.lock(false);
   fe$utils.removeClass('loading', this.getElement());
}

FE$MultiChoiceRenderer.prototype.render = function (where, lang) {
   var def = this.getDefinition();
   this._optionHelper = new FE$OptionHelper(this.getDefinition(), this.getProxy(), null, def.sort !== false);

   console.log('[FER] Called stylized choice render')
   // var container = this.getElement();

   if (def.separator) {
      this._separator = def.separator;
   }
   var dependencies = this._optionHelper.getDependencies()
   for (var i = 0; i < dependencies.length; i++) {
      this.subscribeToChangesOn(dependencies[i]);
   }

   if (def.label) {
      this._label = document.createElement('label')

      this._label.setAttribute('class', 'FE-controlR-label FE-multichoiceR-label');
      where.appendChild(this._label);
   }

   this._input = document.createElement('div');
   this._input.setAttribute('class', 'FE-controlR-control FE-multichoiceR-control FE-multichoiceraw-control');
   this._input.addEventListener('click', this._toggleCombo.bind(this));
   this._input.addEventListener('keyup', this._onKeyUp.bind(this));
   this._input.addEventListener('keydown', this._onKeyDown.bind(this));

   if(def.hasOwnProperty('tabIndex')) {
      this._input.setAttribute('tabIndex', def.tabIndex)
      this._tabIndex = def.tabIndex;
   }
   

   this._placeholder = document.createElement('div');
   this._placeholder.setAttribute('class', 'FE-controlR-placeholder');
   this._input.appendChild(this._placeholder);

   var downBtn = document.createElement('div');
   downBtn.setAttribute('class', 'FE-controlR-handler');
   this._input.appendChild(downBtn);
   where.appendChild(this._input);


   this._options = new Array();
   this._optionsContainer = document.createElement('div');
   this._optionsContainer.setAttribute('class', 'FE-multichoiceR-options');
   this._optionsContainer.style.boxSizing = 'border-box';

   if(def.placeholder2){   
      this._placeholder2 = document.createElement('div');
      this._placeholder2.setAttribute('class', 'FE-controlR-placeholder2');
      this._optionsContainer.appendChild(this._placeholder2);
   }

   where.appendChild(this._optionsContainer);
   
   where.addEventListener('mouseleave',this._close.bind(this))
   
   this.translateTo(lang);
   this._refresh(this.getDefinition());
}

FE$MultiChoiceRenderer.prototype._close = function () {
   console.log('Detected outer close');
   if (this._isOpen) {
      this._toggleCombo();
   }
}
FE$MultiChoiceRenderer.prototype.lock = function (doLock) {
   console.log('[FER_Ltxt] Locking: ' + doLock);
   this._isLocked = doLock;
   if (doLock) {
      this._input.setAttribute('disabled', true);
   } else {
      this._input.removeAttribute('disabled');
   }
}
/* -------------------- HARCODED FOOTER RENDERER ----------------------- */
function FE$HardcodedFooterRenderer() {
   this._container = null;
   this._legalLnk = null;
   this._cookiesLnk = null;
   this._cookieCfgLnk = null;
   this._mailLnk = null;
   this._customerSupportLnk = null;
   this._copyright = null;
   this._img = null;

   this._i18n = {
      "legal": {
         "es": "Aviso legal y privacidad",
         "ca": "Avís legal i privacitat",
         "en": "Legal information and privacy",
         "pt": "Aviso legal e privacidade"
      },
      "cookies": {
         "es": "Cookies",
         "ca": "Cookies",
         "en": "Cookies policy",
         "pt": "Cookies"
      },
      "cookiescfg": {
         "es": "Configuración de las Cookies",
         "ca": "Configuració de les Cookies",
         "en": "Cookies settings",
         "pt": "Configuração de Cookies"
      },
      "support": {
         "es": "Atención al usuario",
         "ca": "Atenció a l'usuari",
         "en": "User support",
         "pt": "Serviço ao usuário"
      },
      "legallink": {
         "es": "https://legal.fundacionlacaixa.org/n/actual/legal-notice_es.html",
         "ca": "https://legal.fundacionlacaixa.org/n/actual/legal-notice_ca.html",
         "en": "https://legal.fundacionlacaixa.org/n/actual/legal-notice_en.html",
         "pt": "https://legal.fundacionlacaixa.org/n/actual/legal-notice_pt.html"

      },
      "cookieslink": {
         "es": "https://legal.fundacionlacaixa.org/n/actual/cookies_es.html",
         "ca": "https://legal.fundacionlacaixa.org/n/actual/cookies_ca.html",
         "en": "https://legal.fundacionlacaixa.org/n/actual/cookies_en.html",
         "pt": "https://legal.fundacionlacaixa.org/n/actual/cookies_pt.html"
      },
      "maillink": {
         "es": "mailto:info@fundaciolacaixa.org",
         "ca": "mailto:info@fundaciolacaixa.org",
         "en": "mailto:info@fundaciolacaixa.org",
         "pt": "mailto:info@fundaciolacaixa.org"
      },
      "copyright": {
         "es": "© Fundació Bancària Caixa d'Estalvis i Pensions de Barcelona, ”la Caixa”. Todos los derechos reservados.",
         "ca": "© Fundació Bancària Caixa d'Estalvis i Pensions de Barcelona, ”la Caixa”. Tots els drets reservats.",
         "en": "© Fundació Bancària Caixa d'Estalvis i Pensions de Barcelona, ”la Caixa”. All rights reserved",
         "pt": "© Fundació Bancària Caixa d’Estalvis i Pensions de Barcelona, ”la Caixa”. Todos os direitos reservados."
      },
      "imagesrc": {
         "es": "https://image.news.fundacionlacaixa.org/lib/fe3215707564067b7c1077/m/4/ae21865d-1b24-4415-8892-dcc65da2f60b.png",
         "ca": "https://image.news.fundacionlacaixa.org/lib/fe3215707564067b7c1077/m/4/19bfd577-385e-4b91-b6b5-229b3225bb2f.png",
         "en": "https://image.news.fundacionlacaixa.org/lib/fe3215707564067b7c1077/m/4/a702b1e0-bc78-4306-b646-00d008f4ee1e.png",
         "pt": "https://image.news.fundacionlacaixa.org/lib/fe3e15707564067d761778/m/3/flc_footer_rect_pt.jpg"
         /* "https://image.news.fundacionlacaixa.org/lib/fe3215707564067b7c1077/m/4/9dc8c78d-c5e4-447d-8ca1-c444ed9132c6.png" */
      }
   }
}

FE$HardcodedFooterRenderer.prototype = new FE$BaseRenderer();

FE$HardcodedFooterRenderer.prototype.getType = function () {
   return 'hcfooter';
}
FE$HardcodedFooterRenderer.prototype.getVariant = function () {
   return 'raw';
}
FE$HardcodedFooterRenderer.prototype.isValueControl = function () {
   return false;
}

FE$HardcodedFooterRenderer.prototype.render = function (where, lang) {
   let def = this.getDefinition();
   if (def.i18n) {
      // At the moment only applies to i18N
      this._i18n = Object.assign(this._i18n, def.i18n);
   }

   this._container = document.createElement('div');
   this._container.setAttribute('class', 'FE-hcFooter');
   where.appendChild(this._container);

   this._img = document.createElement('img');


   this._container.appendChild(this._img);

   var links = document.createElement('div');
   links.setAttribute('class', 'FE-hcFooter-links');
   this._container.appendChild(links);

   this._legalLnk = document.createElement('a');
   this._legalLnk.setAttribute('target', '_blank');

   this._cookiesLnk = document.createElement('a');
   this._cookiesLnk.setAttribute('target', '_blank');

   /* <a href="#" class="ot-sdk-show-settings">##TEXTO DE ENLACE##</a> */
   this._cookieCfgLnk = document.createElement('a');
   this._cookieCfgLnk.classList.add('ot-sdk-show-settings');
   this._cookieCfgLnk.style.cursor = 'pointer';

   this._mailLnk = document.createElement('a');
   this._mailLnk.setAttribute('target', '_blank');

   this._customerSupportLnk = document.createElement('a');
   this._customerSupportLnk.setAttribute('target', '_blank');
   links.appendChild(this._customerSupportLnk);

   // this._mailLnk = document.createElement('a');
   // this._mailLnk.setAttribute('target', '_blank');
   // links.appendChild(this._mailLnk);

   links.appendChild(this._legalLnk);
   links.appendChild(this._cookiesLnk);
   links.appendChild(this._cookieCfgLnk);

   this._copyright = document.createElement('div');
   this._copyright.setAttribute("class", "FE-hcFooter-copyright");
   this._container.appendChild(this._copyright);
   this.translateTo(lang);
}

FE$HardcodedFooterRenderer.prototype.translateTo = function (lang) {
   console.log('[FE_hcf] Translating to ' + lang);
   let def = this.getDefinition();
   var idFuente = fe$utils.getUrlParameter('idf');

   let customerSupportURL = Constants.FORM_CLIENT_OACSUPPORT[lang];
   var destinyIdFuente = customerSupportURL.substring(customerSupportURL.lastIndexOf('=') + 1);

   while (this._legalLnk.hasChildNodes()) {
      this._legalLnk.removeChild(this._legalLnk.firstChild);
   }
   this._legalLnk.href = this._i18n.legallink[lang];
   this._legalLnk.appendChild(document.createTextNode(this._i18n.legal[lang]));

   while (this._cookiesLnk.hasChildNodes()) {
      this._cookiesLnk.removeChild(this._cookiesLnk.firstChild);
   }
   this._cookiesLnk.href = this._i18n.cookieslink[lang];
   this._cookiesLnk.appendChild(document.createTextNode(this._i18n.cookies[lang]));

   while (this._cookieCfgLnk.hasChildNodes()) {
      this._cookieCfgLnk.removeChild(this._cookieCfgLnk.firstChild);
   }
   this._cookieCfgLnk.appendChild(document.createTextNode(this._i18n.cookiescfg[lang]));

   // while (this._mailLnk && this._mailLnk.hasChildNodes()) {
   //    this._mailLnk.removeChild(this._mailLnk.firstChild);
   // }

   while (this._customerSupportLnk && this._customerSupportLnk.hasChildNodes()) {
      this._customerSupportLnk.removeChild(this._customerSupportLnk.firstChild);
   }

   if (def.oacsource && idFuente !== destinyIdFuente) { //Se recibe el parámetro de Origen de redirección al Soporte, y es distinto del Formulario actual
      this._customerSupportLnk.href = customerSupportURL + '&origen=' + def.oacsource;
      this._customerSupportLnk.appendChild(document.createTextNode(this._i18n.support[lang]));
   } else if (idFuente == destinyIdFuente) { //El Id del formulario de destino es el mismo que el Formulario actual
      //**Code if it is detected that we are already in the Customer Service form**//
   } else { //Funcionamiento por defecto, generalmente cuando no se reciba el parámetro de Origen, por seguridad
      // this._mailLnk.href = this._i18n.maillink[lang];
      // this._mailLnk.appendChild(document.createTextNode(this._i18n.support[lang]));
      this._customerSupportLnk.href = customerSupportURL + '&origen=General';
      this._customerSupportLnk.appendChild(document.createTextNode(this._i18n.support[lang]));
   }

   while (this._copyright.hasChildNodes()) {
      this._copyright.removeChild(this._copyright.firstChild);
   }
   this._copyright.appendChild(document.createTextNode(this._i18n.copyright[lang]));
   console.log('[FE_hcf] Image set to: ' + this._i18n.imagesrc[lang] + ' for lang ' + lang);
   this._img.src = this._i18n.imagesrc[lang];
}

/* -------------------- INVITATION RENDERER ----------------------- */
function FE$InvitationRenderer() {
   this._main = null;
   this._label = null;
   this._labelgs = [];
   this._ctrgs = [];

   this._optionlbls = [];
   this._optionrows = {};

   this._selected = {};

   this._tabIndex = 0;
}

FE$InvitationRenderer.prototype = new FE$BaseRenderer();

FE$InvitationRenderer.prototype.getType = function () {
   return 'invitation';
}
FE$InvitationRenderer.prototype.getVariant = function () {
   return 'raw';
}
FE$InvitationRenderer.prototype.getValue = function () {
   var ret = { "": { 'attendees': [], 'sessions': [] } }

   var labels = {};
   var def = this.getDefinition();
   //injecting the byGroup code
   if (def.bySessions) {
      let res = this.getValueBySession(def, this.getDefaultLanguage()); //default lang?!
      ret[''].bySessions = res.bySessions
      ret[''].friendly = res.friendly;
      return ret;
   }
   var translate = this.getTranslator();

   for (var i = 0; i < def.options.length; i++) {
      labels[def.options[i].value] = def.options[i][this.getDefaultLanguage()];
   }
   for (var i = 0; i < this._ctrgs.length; i++) {
      var idx = this._ctrgs[i].selectedIndex;

      var gv = parseInt(this._ctrgs[i].options[idx].value);
      ret[''].attendees.push(gv);

   }

   for (var k in this._selected) {
      if (this._selected[k] === true) {
         ret[''].sessions.push(k);

      }
   }
   ret['friendly'] = '';
   for (var i = 0; i < def.options.length; i++) {
      var v = def.options[i].value;
      ret['friendly'] += def.options[i][this.getDefaultLanguage()] + ' [';
      for (var j = 0; j < def.groups.length; j++) {
         var idx = this._ctrgs[j].selectedIndex;
         var gv = this._ctrgs[j].options[idx].value;
         console.log('[FE_inv] Selected index ' + i + ' is ' + idx + '. Value: ' + gv);
         ret['friendly'] += this._selected[v] === true ? gv : 0;
         // ret['friendly'] += '(' + translate(def.groups[j].label) + ')';
         if (j < def.groups.length - 1) {
            ret['friendly'] += '+';
         }
      }
      ret['friendly'] += ']';
      if (i < def.options.length - 1) {
         ret['friendly'] += ';';
      }
   }
   return ret;

}
/**
 * Renders an Elem and insert it into the target. 
 * 
 * @param {*} target HTMLElement where the object will be inserted
 * @param {*} elem The elem to render (div, select, textarea, ...etc.)
 * @param {*} classes The style of the option
 * @returns  The elem object
 * 
 *  
 * @author Domingo Jurado Fuertes
 */

FE$InvitationRenderer.prototype.renderLabel = function (target, text, classes) {
   let lbl = document.createElement('label');
   classes && lbl.setAttribute('class', classes);
   lbl.appendChild(document.createTextNode(text));
   target.appendChild(lbl);
   return lbl;
}

/**
 * Renders an Elem and insert it into the target. 
 * 
 * @param {*} target HTMLElement where the object will be inserted
 * @param {*} elem The elem to render (div, select, textarea, ...etc.)
 * @param {*} classes The style of the option
 * @returns  The elem object
 * 
 *  
 * @author Domingo Jurado Fuertes
 */
FE$InvitationRenderer.prototype.renderElem = function (target, elem, classes) {
   let e = document.createElement(elem);
   classes && e.setAttribute('class', classes);
   target && target.appendChild(e);
   return e;
}

/**
 * Renders an option and insert it into the target. 
 * 
 * @param {*} target HTMLElement where th object will be inserted
 * @param {*} text The option's text
 * @param {*} value The option's value
 * @param {*} classes The style of the option
 * @returns  The option object
 * 
 *  
 * @author Domingo Jurado Fuertes
 */
FE$InvitationRenderer.prototype.renderOption = function (target, text, value, classes, tabIndex) {
   let o = document.createElement('option');
   o.appendChild(document.createTextNode(text));
   o.setAttribute('value', value);
   tabIndex && o.setAttribute('tabIndex', tabIndex)
   classes && o.setAttribute('class', classes);
   target && target.appendChild(o);
   return o;
}

/**
 * Renders the component grouping by session
 * @param {*} where the HTMLElem where the component will be inserted
 * @param {*} lang the language of the text in the component
 * @param {*} def the definition object
 * 
 * @author Domingo Jurado Fuertes
 */
FE$InvitationRenderer.prototype.renderBySession = function (where, lang, def) {
   // Prerequisites groups needed
   if (!def.groups) {
      throw new FEngineException('Number of groups is required in invitation renderer');
   }
   // Prerequisites optinos needed
   if (!def.options) {
      throw new FEngineException('Sessions are required in invitation by session renderer');
   }

   var translate = this.getTranslator();

   // Main container
   this._main = this.renderElem(where, 'div', 'FE-invitationR-ctr FE-invitationR-ctr_multiple');

   // Build the main label description
   if (def.label) {
      this._label = this.renderLabel(this._main, translate(def.label, lang), 'FE-controlR-label FE-invitationR-label');
   }
   if(def.hasOwnProperty('tabIndex'))
      this._tabIndex = def.tabIndex;
   
   let tabIndex = this._tabIndex;
   // For each Session we create a Session Selector
   for (let i in def.options) {
      // Container with interaction over the selection
      let item = this.renderElem(this._main, 'div', 'FE-invitationR-session');

      // Simulation of session's checkbox with image + label     
      let input = this.renderElem(item, 'div', 'FE-invitation-sessioncontrol');
      input.setAttribute('id', def.options[i].value);
      console.log('aguinaco',tabIndex)
      tabIndex && input.setAttribute('tabIndex', ++tabIndex)
      input.addEventListener('click', (e) => {
         e.currentTarget.parentNode.classList.toggle("selected");
         e.currentTarget.parentNode.getElementsByClassName('FE-controlR-groups')[0].classList.toggle('hidden');
      });
      input.addEventListener('keyup', (e) => {
         if (e.key == " " || e.code == "Space") {
            e.preventDefault();
            e.currentTarget.parentNode.classList.toggle("selected");
            e.currentTarget.parentNode.getElementsByClassName('FE-controlR-groups')[0].classList.toggle('hidden');
         }
      });
      input.addEventListener('keydown', (e) => {
         if (e.key == " " || e.code == "Space") {
            e.preventDefault();
         }
      });
      this.renderLabel(item, def.options[i][lang] || def.options[i].es || 'No translation or default value', 'FE-invitation-sessionlabel');

      // The session's groups container 
      let groups = this.renderElem(item, 'div', 'FE-controlR-groups hidden');

      for (let j in def.groups) {
/*
         let min = def.groups[j].min;
         let max = def.groups[j].max;
*/
        let {min,max} = def.groups[j]
         // For each group create a label and selector
         this.renderLabel(groups, def.groups[j][lang] || def.groups[j].es || 'No translation or default value', (min == max) ? 'hidden' : 'FE-controlR-glabel');

         // If there is only one option, we hide the selector       
         let ctr = this.renderElem(groups, 'select', (min == max) ? 'hidden' : 'FE-controlR-ginput');
         //ctr.setAttribute('id','g'+j+'_'+def.options[i].value);

         if (!max || max < min) {
            max = min;
         }
         for (var z = min; z <= max; z++) {
            tabIndex && ++tabIndex
            this.renderOption(ctr, z, z, null, tabIndex);
         }
      }
   }
}

FE$InvitationRenderer.prototype.getValueBySession = function (def, lang) {
   var ret = { 'bySessions': [], 'friendly': '' };

   // For each session
   for (let i in def.options) {
      let check = document.getElementById(def.options[i].value);
      if (check && check.parentNode.classList.contains('selected')) {
         let selectors = check.parentNode.getElementsByTagName('select');
         //If selected push the id and groups 1 and 2 
         ret.bySessions.push({
            'id': def.options[i].value,
            'attendees': [
               selectors[0].value,
               selectors[1] ? selectors[1].value : 0
            ]
         });

         ret.friendly += def.options[i][lang] + " " + selectors[0].value + " " + def.groups[0][lang] + " " + (selectors[1] ? selectors[1].value : 0) + " " + (def.groups[1] ? def.groups[1][lang] : '') + "\n";
      }
   }
   return ret;
}
FE$InvitationRenderer.prototype.render = function (where, lang, def) {
   def = this.getDefinition();

   if (def.bySessions) {
      this.renderBySession(where, lang, def);
      return;
   }
   this._main = document.createElement('div');
   this._main.setAttribute('class', 'FE-invitationR-ctr ' + (def.multiple ? 'FE-invitationR-ctr_multiple' : 'FE-invitationR-ctr_single'));
   where.appendChild(this._main);

   if (!def.groups) {
      throw new FEngineException('Number of groups is required in invitation renderer');
   }

   if (def.label) {
      this._label = document.createElement('label');
      this._label.setAttribute('class', 'FE-controlR-label FE-invitationR-label')
      this._main.appendChild(this._label);
   }

   var groups = document.createElement('div');
   groups.setAttribute('class', 'FE-controlR-groups');
   this._main.appendChild(groups);

   for (var i = 0; i < def.groups.length; i++) {
      var lbl = document.createElement('label');
      lbl.setAttribute('class', 'FE-controlR-glabel');
      this._labelgs.push(lbl);
      var ctr = document.createElement('select');
      ctr.setAttribute('class', 'FE-controlR-ginput');
      var min = def.groups[i].min;
      var max = def.groups[i].max;
      if (!max || max < min) {
         max = min;
      }
      for (var j = min; j <= max; j++) {
         var opt = document.createElement('option');
         opt.setAttribute('value', j);
         opt.appendChild(document.createTextNode('' + j));
         ctr.appendChild(opt);
      }
      groups.appendChild(lbl);
      groups.appendChild(ctr);

      this._ctrgs.push(ctr);
   }
   var sessionsEl = document.createElement('div');
   sessionsEl.setAttribute('class', 'FE-invitationR-sessions');
   this._main.appendChild(sessionsEl);
   for (var i = 0; i < def.options.length; i++) {
      var item = document.createElement('div');
      item.setAttribute('class', 'FE-invitationR-session' + (def.options[i].disabled === true ? ' disabled' : ''));
      if (def.options[i].disabled !== true) {
         item.addEventListener('click', this._onClick.bind(this, i));
         item.addEventListener('keyup', this._onKeyDown.bind(this, i));
         item.addEventListener('keydown', this._onKeyUp.bind(this, i));
      }
      sessionsEl.appendChild(item);
      var input = document.createElement('div');

      this._optionrows[def.options[i].value] = item;

      input.setAttribute('class', 'FE-invitation-sessioncontrol');
      if(def.hasOwnProperty('tabIndex')){
         input.setAttribute('tabIndex', def.tabIndex)
         this._tabIndex = def.tabIndex;
      }
      
      item.appendChild(input);

      var label = document.createElement('label')
      label.setAttribute('class', 'FE-invitation-sessionlabel');
      this._optionlbls.push(label);
      item.appendChild(label);
   }
   if (!def.multiple || def.options.length == 1) {
      // Search first option enabled
      for (var i = 0; i < def.options.length; i++) {
         console.log('[DES] Checking disabled ' + JSON.stringify(def.options[i]));
         if (!('disabled' in def.options[i]) || def.options[i].disabled === false) {
            this._onClick(i);
            break;
         }
      }

   }

   if (def.options.length == 1) {
      if (def.groups.length == 1 && def.groups[0].max == 1) {
         this.getElement().parentNode.style.display = 'none';
      } else {
         sessionsEl.style.display = 'none';
      }
   }
   this.translateTo(lang);
}
FE$InvitationRenderer.prototype._onKeyDown = function (index) {
   if (fe$utils.isSpaceBar(event)) 
      event.preventDefault();
}

FE$InvitationRenderer.prototype._onKeyUp = function (index) {
   if (fe$utils.isSpaceBar(event)) {
      event.preventDefault();
      this._onClick(index)
   }
}

FE$InvitationRenderer.prototype._onClick = function (index) {
   console.log('[FE_inv] Clicked option ' + index + ' - ' + JSON.stringify(this._optionrows));
   var def = this.getDefinition();

   var v = def.options[index].value;
   if (def.multiple) { // Update map of selected options according to whether it is multiple or not
      this._selected[v] = !this._selected[v];
   } else {
      for (var k in this._selected) {
         this._selected[k] = false;
      }
      this._selected[v] = true;

      console.log('[FE_inv] Handling ' + v);
   }
   console.log('[FE_inv] Options: ' + JSON.stringify(this._selected));
   for (var i = 0; i < def.options.length; i++) { // Mark selected
      var option = def.options[i].value;
      console.log('[FE_inv] Changing option ' + option + ' to ' + this._selected[option]);
      fe$utils.removeClass('selected', this._optionrows[option]);
      if (this._selected[option] === true) {
         fe$utils.addClass('selected', this._optionrows[option]);
      }
   }
}

FE$InvitationRenderer.prototype.translateTo = function (lang) {
   var translate = this.getTranslator();
   var def = this.getDefinition();
   if (def.label) {
      fe$utils.clearChildren(this._label);

      this._label.appendChild(document.createTextNode(translate(def.label, lang)));
   }

   for (var i = 0; i < this._labelgs.length; i++) {
      fe$utils.clearChildren(this._labelgs[i]);
      if (lang in def.groups[i]) {

         this._labelgs[i].appendChild(document.createTextNode((i > 0 ? '/ ' : '') + def.groups[i][lang]));
      } else if (this.getDefaultLanguage() in def.groups[i]) {
         this._labelgs[i].appendChild(document.createTextNode((i > 0 ? '/ ' : '') + def.groups[i][this.getDefaultLanguage()]));
      } else {
         this._labelgs[i].appendChild(document.createTextNode((i > 0 ? '/ ' : '') + '#NoGroupText' + (i + 1) + '#'));
      }
   }

   for (var i = 0; i < this._optionlbls.length; i++) {
      var text = 'No translation for session ' + i;
      if (lang in def.options[i]) {
         text = def.options[i][lang];
      } else if (this.getDefaultLanguage() in def.options[i]) {
         text = def.options[i][this.getDefaultLanguage()];
      }
      fe$utils.clearChildren(this._optionlbls[i]);
      this._optionlbls[i].appendChild(document.createTextNode(text));
   }
}

/* -------------------- SIMPLE DATE RENDERER ----------------------- */
function FE$SimpleDateRenderer() {
   this._langSvc = null;
   this._input = null;
   this._label = null;
   this.INITIAL_VALUE = '________';


   this._focused = false;

   this._caretStart = 0;
   this._caretEnd = 0;

   this._value = this.INITIAL_VALUE;
   this._shiftDown = false;
   this.SHIFT = 16;
   this._valid = false;
}
FE$SimpleDateRenderer.prototype = new FE$BaseRenderer();

FE$SimpleDateRenderer.prototype.getType = function () {
   return 'date';
}
FE$SimpleDateRenderer.prototype.getVariant = function () {
   return 'simple';
}
FE$SimpleDateRenderer.prototype.setValue = function (v) {
   console.log('[FER_sdt] Setting value of simple date renderer to ' + v);
   if (v != null && v != undefined && v.length > 0) {
      this._value = v.replace(/\//g, '');
      this.showValue();
      this.notifyChange();
   }

}

FE$SimpleDateRenderer.prototype.getValue = function () {
   console.log('[FER_sdt] Obtaining value from SimpleDate: ' + this._value);
   if (this._value == this.INITIAL_VALUE) {
      return null;
   }
   return this._value.substring(0, 2) + '/' + this._value.substring(2, 4) + '/' + this._value.substring(4, 8);

}

FE$SimpleDateRenderer.prototype._checkValid = function () {
   console.log('***** [FER_sdt] Validating date: ' + this._value);
   var valid = true;
   if (this._value != this.INITIAL_VALUE) { // Check only if not empty
      if (!this._value.match('[0-9]{8}')) {
         valid = false;
      }
      if (valid) {
         var day = parseInt(this._value.substring(0, 2), 10);
         var month = parseInt(this._value.substring(2, 4), 10) - 1;
         var year = parseInt(this._value.substring(4, 8), 10);
         var dt = new Date(year, month, day, 0, 0, 0, 0);

         var aDay = dt.getDate();
         var aMonth = dt.getMonth();
         var aYear = dt.getFullYear();

         if (aDay != day || aMonth != month || aYear != year) {
            valid = false;
         }
      }
   }
   fe$utils.removeClass('error', this._wrapper)
   if (!valid) {
      fe$utils.addClass('error', this._wrapper)
   }
   console.log('[FER_sdt] Value ' + this._value + ' is valid? ' + valid);
   return valid;
}

FE$SimpleDateRenderer.prototype.lock = function (doLock) {
   console.log('[FER_Txt] Locking: ' + doLock);
   if (doLock) {
      this._input.setAttribute('disabled', true);
   } else {
      this._input.removeAttribute('disabled');
   }
}
FE$SimpleDateRenderer.prototype.translateTo = function (lang) {
   var def = this.getDefinition();
   var langSvc = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.childNodes[0])
      }
      this._label.innerHTML = langSvc(def.label, lang);
   }
   if (def.placeholder) {
      this._input.setAttribute('placeholder', langSvc(def.placeholder, lang));
   }
   this.showValue();
}
FE$SimpleDateRenderer.prototype._onFocus = function (e) {
   console.log('FOCUSED!!');
   fe$utils.addClass('FE-state-focus', this.getElement());
   this._focused = true;
   this.showValue();
   setTimeout(function () {
      this._input.setSelectionRange(0, 0);
      this._onCaretChange(e);
   }.bind(this), 100);
}
FE$SimpleDateRenderer.prototype._onBlur = function (e) {
   console.log('BLURRED!!');
   this._focused = false;
   fe$utils.removeClass('FE-state-focus', this.getElement());
   this.showValue();
}
FE$SimpleDateRenderer.prototype._onKeyPress = function (e) {
   e.preventDefault(); // Prevents writing on input
   console.log('[FER_sdt] Press event: ', e);
   return false;
}

FE$SimpleDateRenderer.prototype._onKeyUp = function (e) {
   e.preventDefault();
   console.log('[FER_sdt] Up event: ', e);
   console.log('[FER_sdt] Simple date key up: ' + this._input.value);
   if (e.keyCode == this.SHIFT) {
      this._shiftDown = false;
   }
   return false;

}

FE$SimpleDateRenderer.prototype._onClick = function (e) {
   this._onCaretChange(e);
}

FE$SimpleDateRenderer.prototype._fromInputToInternal = function () {
   var carets = [this._input.selectionStart, this._input.selectionEnd];
   for (var i = 0; i < carets.length; i++) {
      if (carets[i] >= 6) {
         carets[i] -= 2;
      } else if (carets[i] >= 3) {
         carets[i] -= 1;
      }
   }
   this._caretStart = carets[0];
   this._caretEnd = carets[1];
   console.log('[FER_sdt] Converted to internal: ' + this._input.selectionStart + '-' + this._input.selectionEnd + ' to ' + carets[0] + '-' + carets[1]);
}

FE$SimpleDateRenderer.prototype._fromInternalToInput = function () {
   var carets = [this._caretStart, this._caretEnd];
   for (var i = 0; i < carets.length; i++) {
      if (carets[i] > 4) {
         carets[i] += 2;
      } else if (carets[i] > 2) {
         carets[i] += 1;
      }
   }
   console.log('[FER_sdt] Converted internal: ' + this._caretStart + '-' + this._caretEnd + ' to input ' + carets[0] + '-' + carets[1]);
   return carets;
}

FE$SimpleDateRenderer.prototype._onCaretChange = function (e) {
   console.log('[FER_sdt] Posible caret change: ' + this._input.selectionStart + ' - ' + this._input.selectionEnd);
   this._fromInputToInternal();
   console.log('[FER_sdt] Caret changed to: ' + this._caretStart + ' - ' + this._caretEnd);
   var carets = this._fromInternalToInput();
   this._input.setSelectionRange(carets[0], carets[1]);
}

FE$SimpleDateRenderer.prototype._onInput = function (e) {
   console.log('[FER_sdt]--------------------');
   console.log('[FER_sdt]INPUT: Input event: ', e);
   var v = this._input.value.replace(/\//gi, '').replace(/[^0-9]/gi, '_');
   console.log('[FER_sdt]INPUT: Replaced value as: ' + v);
   var pos = this._input.selectionStart;

   if (e.inputType != "deleteContentBackward") {

      if (pos == 3 || pos == 6) {
         console.log('[FER_sdt]INPUT: Incrementing position: ' + pos);
         pos++;
      }

      if (v.length > 8) {
         v = v.substring(0, 8);
      }
      this._value = v;

   } else {
      console.log('[FER_sdt]INPUT: Deleting char');
      if (pos == 3 || pos == 6) {
         console.log('[FER_sdt]INPUT: Decrementing position: ' + pos);
         pos--;
      }
      while (v.length < 8) {
         v += '_';
      }
      this._value = v;
   }
   console.log('[FER_sdt]INPUT: Value after input handling: ' + this._value);
   this.showValue();
   console.log('[FER_sdt]INPUT: Setting caret to: ' + pos);
   setTimeout(function (pos) {
      this._input.setSelectionRange(pos, pos);
      console.log('[FER_sdt]INPUT: Caret set to: ' + pos);
   }.bind(this, pos), 0); // For some reason must be done referred
   this._checkValid();


}

FE$SimpleDateRenderer.prototype._onKeyDown = function (e) {
   var LEFT = 37;
   var RIGHT = 39;
   var BSPACE = 8;
   var TAB = 9;
   var DEL = 46;

   var x = e.keyCode;  // Get the Unicode value
   console.log('[FER_sdt] Down event: ', e);

   if (x == 229 || x==TAB) {
      console.log('[FER_sdt] Ignoring ', x);
      return false;
   }
   e.preventDefault();
   this._fromInputToInternal();
   console.log('[FER_sdt] Before key caret: ' + this._caretStart + ' - ' + this._caretEnd + '. Value: ' + this._input.value);

   console.log('[FER_sdt] Key code: ' + x);
   if (x == this.SHIFT) {
      this._shiftDown = true;
   } if (x == RIGHT) {
      if (this._caretEnd < this._value.length) {

         if (this._shiftDown) {
            this._caretEnd++;
         } else {
            this._caretStart++;
            this._caretEnd++;

         }
      }
   } else if (x == LEFT) {
      if (this._caretStart > 0) {
         this._caretStart--;
         if (!this._shiftDown) {
            this._caretEnd = this._caretStart;
         }
      }
   } else if (x == BSPACE) {

      if (this._caretStart == this._caretEnd) {
         if (this._caretStart > 0) {
            this._value = this._value.substring(0, this._caretStart - 1) + this._value.substring(this._caretEnd, this._value.length)
            this._caretStart--;
         }
      } else {
         this._value = this._value.substring(0, this._caretStart) + this._value.substring(this._caretEnd, this._value.length)
      }


      this._caretEnd = this._caretStart;
   } else if (x == DEL) {
      if (this._caretStart != this._caretEnd) {

         console.log('[FER_sdt] Deletion')
         this._value = this._value.substring(0, this._caretStart) + this._value.substring(this._caretEnd, this._value.length)
      } else if (this._caretStart < this._value.length) {
         this._value = this._value.substring(0, this._caretStart) + this._value.substring(this._caretEnd + 1, this._value.length)
      }
      this._caretEnd = this._caretStart;
   } else {
      var y = String.fromCharCode(x)
      if (x >= 96 && x <= 105) {
         y = '0' + x - 96; // Num keyboard '0' -> 96, '9' -> 105
      }
      if ((y >= '0' && y <= '9')) {
         this._value = this._value.substring(0, this._caretStart) + y + this._value.substring(this._caretEnd, this._value.length);
         this._value = this._value.substring(0, 8);

         this._caretStart++;
         this._caretEnd = this._caretStart;
      } else {
         console.log('[FER_sdt] Exiting...because code is unknown: "' + y + '" (' + x + ')');
         return false;
      }
   }

   // Fill remaining 
   console.log('[FER_sdt] Value length: ' + this._value.length);
   var remaining = 8 - this._value.length;
   for (var i = 0; i < remaining; i++) {
      console.log('[FER_sdt] Appending _');
      this._value += '_';
   }

   this.showValue();
   var carets = this._fromInternalToInput();

   this._input.setSelectionRange(carets[0], carets[1]);
   this._checkValid();
   console.log('[FER_sdt] Simple date key down: ' + this._input.value + ' (' + this._value + ') - Caret pos: ' + this._caretStart + ' - ' + this._caretEnd);
   return false;
}

FE$SimpleDateRenderer.prototype.showValue = function () {
   console.log('[FER_sdt] Showing value ' + this._value + ' with focused: ' + this._focused);
   if (!this._focused && this._value == this.INITIAL_VALUE) {
      this._input.value = '';
      this._input.classList.remove("floating-label-top");
   } else {
      var day = this._value.substring(0, 2);
      day = day.replace(/\_/gi, 'd');
      var month = this._value.substring(2, 4);
      month = month.replace(/_/gi, 'm');
      var year = this._value.substring(4, 8);
      if (this._lang == 'en') {
         year = year.replace(/\_/gi, 'y');
      } else {
         year = year.replace(/\_/gi, 'a');
      }
      this._input.value = day + '/' + month + '/' + year;
      
      //FIXME! : this is template dependant, is only need in form02 
      if (!this._input.classList.contains("floating-label-top") && this._input.value)
         this._input.classList.add("floating-label-top");
   }
}

FE$SimpleDateRenderer.prototype.render = function (where, lang) {
   console.log('[FER_sdt] Called simple date render');
   var def = this.getDefinition();
   document.querySelectorAll('.form-control').forEach((ctrl,i) => {
      ctrl.tabIndex = i
  });
   // var container = this.getElement();
   if (def.label) {
      this._label = document.createElement('label')
      // this.label.appendChild(document.createTextNode(def.label))
      this._label.setAttribute('class', 'FE-controlR-label FE-dateR-label FE-simpleDateR-label');
      where.appendChild(this._label);
   }

   this._input = document.createElement('input');


   this._input.addEventListener('focus', this._onFocus.bind(this));
   this._input.addEventListener('blur', this._onBlur.bind(this));
   this._input.addEventListener('keyup', this._onKeyUp.bind(this));
   this._input.addEventListener('keypress', this._onKeyPress.bind(this));
   this._input.addEventListener('keydown', this._onKeyDown.bind(this));
   this._input.addEventListener('click', this._onClick.bind(this));
   var ua = window.navigator.userAgent;
   console.log('[FER_sdt] User agent: ' + ua + ' --------------------------------');
   if (ua.indexOf("MSIE ") == -1 && ua.indexOf("Trident") == -1) {
      console.log('[FER_sdt] Is IE!!! ----------------------------');
      this._input.addEventListener('input', this._onInput.bind(this));
   }


   this._input.setAttribute('name', def.name);
   this._input.setAttribute('type', 'text')
   this._input.setAttribute('class', 'FE-controlR-control FE-dateR-control')
   
   if(def.hasOwnProperty('tabIndex'))   
      this._input.setAttribute('tabIndex', def.tabIndex)

   where.appendChild(this._input);

   this.translateTo(lang);

}

/* -------------------- Multibox RENDERER ----------------------- */
function FE$MultiboxRenderer() {
   this._label = null;
   this._boxes = new Array();
   this._boxesMap = {};
   this._separator = ',';
   this._optionHelper = null;
   this._optionsContainer = null;

}
FE$MultiboxRenderer.prototype = new FE$BaseRenderer();

FE$MultiboxRenderer.prototype.getType = function () {
   return 'multichoice';
}

FE$MultiboxRenderer.prototype.getVariant = function () {
   return 'boxed';
}

FE$MultiboxRenderer.prototype.getValue = function () {
   var ret = {};
   var def = this.getDefinition();
   ret.array = new Array();
   ret[''] = '';
   for (var i = 0; i < this._boxes.length; i++) {
      if (this._boxes[i].checked) {
         ret.array.push({ "value": this._boxes[i].value });

         if (ret[''].length > 0) {
            ret[''] += this._separator;
         }
         ret[''] += this._boxes[i].value;
      }
   }
   return ret;
}

FE$MultiboxRenderer.prototype.setValue = function (v, p) {
   var def = this.getDefinition();
   console.log('[FE_mbx] Setting prop "' + p + '" value to ' + JSON.stringify(v));
   for (var i = 0; i < this._boxes.length; i++) {
      this._select(this._boxes[i], false);
   }
   if (p == def.name + '.array') {
      console.log('[FE_mbx] Setting value to ' + JSON.stringify(v));
      if (!Array.isArray(v)) {
         console.log('[FE_mbx] ERROR:: Trying to set a value that is not an array...' + JSON.stringify(v));
         return;
      }
      for (var i = 0; i < v.length; i++) {
         console.log('[FE_mbx] Checking value ' + i + ' - ' + JSON.stringify(v));
         var boxInfo = this._boxesMap[v[i].value];
         if (boxInfo == null) {
            console.log('[FE_mbx] WARNING:: Trying to set value of box using ' + JSON.stringify(v[i]) + ' but box was not found');
            continue;
         }
         this._select(boxInfo, true);
      }
   }
}

FE$MultiboxRenderer.prototype._select = function (boxInfo, selected) {
   if (selected) {
      console.log('[FE_mbx] Selecting box ' + boxInfo);
   }
   boxInfo.checked = selected;
   if (selected) {
      fe$utils.addClass('selected', boxInfo.box);
   } else {
      fe$utils.removeClass('selected', boxInfo.box);
   }
}
FE$MultiboxRenderer.prototype._onClick = function (which) {
   console.log('[FE_mbx] Clicked box ' + which);
   if (this._locked) {
      return;
   }
   this._select(this._boxes[which], !this._boxes[which].checked);
}

FE$MultiboxRenderer.prototype._refresh = function (def) {
   console.log('[feMB] Reloading options');
   fe$utils.addClass('loading', this.getElement());
   this._value = null;
   var lang = this.getLanguage();
   this.lock(true);
   this._optionHelper.getOptions(lang, this._onOptionsReady.bind(this));
}
FE$MultiboxRenderer.prototype._onKeyUp = function (which) {
   console.log('[FE_mbx] KeyUp box ' + which);
   if (this._locked) {
      return;
   }
   if ((fe$utils.isSpaceBar(event))) {
      event.preventDefault();
      this._select(this._boxes[which], !this._boxes[which].checked);
   }

}
FE$MultiboxRenderer.prototype._onKeyDown = function () {
   if (fe$utils.isSpaceBar(event)) 
      event.preventDefault();
}

FE$MultiboxRenderer.prototype._onOptionsReady = function (data, isFull) {
   console.log('[feMB] Options ready: ', data);
   for (var i = this._optionsContainer.childNodes.length; i > 0; i--) {
      this._optionsContainer.removeChild(this._optionsContainer.childNodes[i]);
   }

   this._boxes = new Array();
   for (var i = 0; i < data.length; i++) {
      var box = document.createElement('div');
      box.setAttribute('value', data[i].value ? data[i].value : 'true');
      box.setAttribute('class', 'FE-controlR-control FE-interestsR-control' + (data[i].height ? ' fixedHeight' : ''))
      if(this.getDefinition().hasOwnProperty('tabIndex'))   
         box.setAttribute('tabIndex', this.getDefinition().tabIndex+i+1);
      box.addEventListener('click', this._onClick.bind(this, i));
      box.addEventListener('keyup', this._onKeyUp.bind(this, i));
      box.addEventListener('keydown', this._onKeyDown.bind(this, i));

      var label = document.createElement('label')
      label.setAttribute('class', 'FE-controlR-label FE-interestsR-label');
      box.appendChild(label);

      var bg = document.createElement('div');
      bg.setAttribute('class', 'FE-controlR-bg FE-interestsR-bg');

      box.appendChild(bg);

      if (data[i].color) {
         box.style.borderColor = data[i].color;
         box.style.color = data[i].color;
         bg.style.backgroundColor = data[i].color;
      } else {
         box.style.borderColor = '#000000';
         box.style.color = '#000000';
         bg.style.backgroundColor = '#000000';
      }

      if (data[i].height) {
         box.style.height = data[i].height;
      }

      this._optionsContainer.appendChild(box);
      var boxInfo = { box: box, label: label, bg: bg, checked: false, value: data[i].value };
      this._boxes.push(boxInfo);
      this._boxesMap[data[i].value] = boxInfo;
   }
   this.translateTo(this.getLanguage());
}

FE$MultiboxRenderer.prototype.render = function (where, lang) {
   var def = this.getDefinition();
   this._optionHelper = new FE$OptionHelper(this.getDefinition(), this.getProxy(), null, def.sort !== false);

   if (def.separator) {
      this._separator = def.separator;
   }
   var dependencies = this._optionHelper.getDependencies()
   for (var i = 0; i < dependencies.length; i++) {
      this.subscribeToChangesOn(dependencies[i]);
   }

   // var container = this.getElement();
   if (def.label) {
      this._label = document.createElement('label')
      // this.label.appendChild(document.createTextNode(def.label))
      this._label.setAttribute('class', 'FE-controlR-label FE-multiboxR-label');
      where.appendChild(this._label);
   }

   this._optionsContainer = document.createElement('div');
   if(def.hasOwnProperty('tabIndex'))   
         this._optionsContainer.setAttribute('tabIndex', def.tabIndex)
   
   where.appendChild(this._optionsContainer);
   this.translateTo(lang);
   this._refresh(this.getDefinition());

}

FE$MultiboxRenderer.prototype.translateTo = function (lang) {
   var def = this.getDefinition();
   var langSvc = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.childNodes[0])
      }
      this._label.innerHTML = langSvc(def.label, lang);
   }

   var translation = this._optionHelper.getTranslationTo(lang);
   for (var i = 0; i < this._boxes.length; i++) {
      var content = null;

      this._boxes[i].label.innerHTML = translation[i].label;
   }
}

/* -------------------- File Upload RENDERER ----------------------- */
function FE$UploadRenderer() {
   this._label = null;
   this._items = new Array();
   this._field = null;

   this._seed = 0;
}
FE$UploadRenderer.prototype = new FE$BaseRenderer();

FE$UploadRenderer.prototype.getType = function () {
   return 'upload';
}

FE$UploadRenderer.prototype._onRemove = function (item, container) {
   console.log('[feUpl] Removing item: ' + item);
   var pos = -1;
   for (var i = 0; i < this._items.length; i++) {
      if (this._items[i] == item) {
         pos = i;
         break;
      }
   }
   this._items.splice(pos, 1);
   container.parentNode.removeChild(container);

}


FE$UploadRenderer.prototype._onFileSelected = function (e) {
   console.log('[feUpl] File ' + e + ' selected');

   var maxFiles = this.getDefinition().maxFiles;
   if (maxFiles && maxFiles <= this._items.length) {
      console.log('[feUpl] Limit of files reached. Stopped in upload input');
      return;
   }

   if (this._field.files && this._field.files.length > 0) {


      var file = this._field.files[0];
      console.log('[feUpl] File ', file);
      var item = { name: file.name, file: file };
      item.size = file.size;
      item.type = file.type;
      var sufix = ['B.', 'KB.', 'MB.', 'GB.'];
      var sufixIdx = 0;
      var size = file.size;
      while (sufixIdx < sufix.length - 1 && size > 1024) {
         size /= 1024;
         sufixIdx++;
      }
      item.friendlySize = Math.floor(size) + sufix[sufixIdx];
      item.type = file.type;
      // For the salesforce destinations (aka undefined) read contents
      // Externals are sent with formdata
      if (this.getDestination() === undefined) {
         var reader = new FileReader();
         reader.onload = function (e) {
            console.log('[feUpl] File read: ' + file.name + ' - ' + reader.result);
            item.data = reader.result;
            this._onAdd(true, item, reader.result);
         }.bind(this);
         reader.onerror = function (e) {
            console.log('[feUpl] File error: ' + e + ' - ' + e.target.error);
            this._onAdd(false, item, e.target.error);
         }.bind(this);
         // reader.readAsArrayBuffer(file);
         reader.readAsDataURL(file);
      } else { // For external destinations add without reading contents
         this._onAdd(true, item);
      }





   }
}

FE$UploadRenderer.prototype._onAdd = function (success, item, errorOnFailure) {
   this._items.push(item);

   if (!success) {
      // TODO: Should be fet$onUnrecoverableError(unrecovErrShown, fileErrors[0]);
      alert('File error: ' + errorOnFailure);
      return;
   }

   var def = this.getDefinition();
   var where = this.getElement();
   var container = document.createElement('div');
   container.setAttribute('class', 'FE-upload-file');
   where.appendChild(container);
   item.container = container;



   var fileLabel = document.createElement('label');
   fileLabel.setAttribute('class', 'FE-upload-filelabel');
   fileLabel.appendChild(document.createTextNode(item.name));
   item.fileLabel = fileLabel;
   container.appendChild(fileLabel);

   var sizeLabel = document.createElement('label');
   sizeLabel.setAttribute('class', 'FE-upload-sizelabel');
   sizeLabel.appendChild(document.createTextNode('(' + item.friendlySize + ')'));
   item.sizeLabel = sizeLabel;
   container.appendChild(sizeLabel);

   var typeLabel = document.createElement('label');
   typeLabel.setAttribute('class', 'FE-upload-sizelabel');
   typeLabel.appendChild(document.createTextNode('(' + item.type + ')'));
   item.typeLabel = typeLabel;
   container.appendChild(typeLabel);

   // Add removal
   var remove = document.createElement('div');
   remove.setAttribute('class', 'FE-upload-remove');
   remove.addEventListener('click', this._onRemove.bind(this, item, container));
   container.appendChild(remove);


   this._seed++;
}
FE$UploadRenderer.prototype.render = function (where, lang) {
   var def = this.getDefinition();
   if (!('name' in def)) {
      throw new FEngineException('No name defined for upload control: ' + JSON.stringify(def));
   }
   console.log('[feUpl] Upload file def: ' + JSON.stringify(def));

   if (def.label) {
      this._label = document.createElement('label')
      // this.label.appendChild(document.createTextNode(def.label))
      this._label.setAttribute('class', 'FE-controlR-label FE-upload-label');
      where.appendChild(this._label);
   }

   var container = document.createElement('div');
   container.setAttribute('class', 'FE-upload-container');
   where.appendChild(container);

   var breakDiv = document.createElement('div');
   breakDiv.setAttribute('class', 'FE-upload-break');
   where.appendChild(breakDiv)
   // this._add();
   this._field = document.createElement('input');
   this._field.setAttribute('type', 'file');
   this._field.setAttribute('name', def.name);
   if (def.accept) {
      this._field.setAttribute('accept', def.accept);
   }
   this._field.addEventListener('change', this._onFileSelected.bind(this));
   if(def.hasOwnProperty('tabIndex'))   
      this._field.setAttribute('tabIndex', def.tabIndex)

   container.appendChild(this._field);

   var overlap = document.createElement('label');
   overlap.setAttribute('class', 'FE-upload-overlap');
   overlap.setAttribute('for', this._field.getAttribute('name'));

   /* var buttonText = 'Choose File';
   overlap.appendChild(document.createTextNode(buttonText)); */
   overlap.addEventListener('click', function (def) {


      if ('maxFiles' in def && def.maxFiles <= this._items.length) {
         console.log('[feUpl] Exceeded max files');
         return;
      } else {
         console.log('[feUpl] Current num of files: ' + this._items.length + ' vs ' + def.maxFiles);
      }
      console.log('[feUpl] Simulating click');
      this._field.click();
   }.bind(this, def));
   container.appendChild(overlap);

   this.translateTo(lang);
}

FE$UploadRenderer.prototype.getFile = function (index) {
   return this._items[index].file;
}
FE$UploadRenderer.prototype.getValue = function () {
   var ret = [];
   for (var i = 0; i < this._items.length; i++) {
      ret.push({
         "file": this._items[i].name,
         "friendlySize": this._items[i].friendlySize,
         "size": this._items[i].size,
         "type": this._items[i].type
      })
   }
   return ret;
}

FE$UploadRenderer.prototype.countFiles = function () {
   return this._items.length;
}


FE$UploadRenderer.prototype.isFileControl = function () {
   // By default all renderers are value containers. But can be overriden for controls like images or labels
   return true;
}

FE$UploadRenderer.prototype.getDestination = function () {
   return (this.getDefinition().destination ? this.getDefinition().destination.url : undefined);
}

FE$UploadRenderer.prototype.getDestinationParameters = function () {
   var ret = {};
   var proxy = this.getProxy();
   if (this.getDefinition().destination && this.getDefinition().destination.parameters) {
      var params = this.getDefinition().destination.parameters;
      for (var k in params) {
         console.log('[feUpl] Calculating parameter: ' + params[k]);
         ret[k] = this.getProxy().fexExecuteString(params[k]);
      }
   }
   return ret;
}

FE$UploadRenderer.prototype.getFileData = function (index) {
   console.log('[feUpl] Getting file data on index ' + index);
   return this._items[index].data;

}

FE$UploadRenderer.prototype.translateTo = function (lang) {
   var def = this.getDefinition();
   var langSvc = this.getTranslator();
   if (this._label) {
      while (this._label.hasChildNodes()) {
         this._label.removeChild(this._label.childNodes[0])
      }
      this._label.innerHTML = langSvc(def.label, lang);
   }
}

/* -------------------- Formula RENDERER ----------------------- */
function FE$FormattedLabelRenderer() {
   this._label = null;
   this._asts = new Array();

}
FE$FormattedLabelRenderer.prototype = new FE$BaseRenderer();

FE$FormattedLabelRenderer.prototype.getType = function () {
   return 'label';
}

FE$FormattedLabelRenderer.prototype.getVariant = function () {
   return 'formatted';
}

FE$FormattedLabelRenderer.prototype.isValueControl = function () {
   return false;
}
FE$FormattedLabelRenderer.prototype.translateTo = function (lang) {
   var translate = this.getTranslator();
   var def = this.getDefinition();

   var replacements = new Array();
   for (var i = 0; i < this._asts.length; i++) {
      replacements.push(this.getProxy().fexExecuteAST(this._asts[i]));
   }
   console.log('[feFmtLbl] Translation for label ' + this.getDefinition().label + ' is ' + text)
   var text = translate(def.label, lang);
   for (var i = 0; i < replacements.length; i++) {
      console.log('[feFmtLbl] Replacing {' + i + '} with "' + replacements[i] + '"');
      text = text.replace(new RegExp('\\{' + i + '}'), decodeURIComponent(replacements[i]));
   }

   this._label.innerHTML = text;

   if (Array.isArray(def.applyAlso)) {
      def.applyAlso.forEach(x => document.querySelector(x) && (document.querySelector(x).innerHTML = text))
   }
}

FE$FormattedLabelRenderer.prototype.render = function (where, lang) {
   var def = this.getDefinition();
   if (!def.label) {
      throw new FEngineException('Formatted label without label attribute in definition');
   }
   this._label = document.createElement('span')
   this._label.setAttribute('class', 'FE-controlR-label');
   where.appendChild(this._label);


   // Compile
   if (def.params) {
      var proxy = this.getProxy();
      for (var i = 0; i < def.params.length; i++) {
         var ast = proxy.fexParseAST(def.params[i]);
         this._asts.push(ast);
         var ids = proxy.fexGetASTIdentifiers(ast);
         for (var j = 0; j < ids.length; j++) {
            console.log('[feFmtLbl] Subscribing to ' + ids[j]);
            this.subscribeToChangesOn(ids[j]);
         }
      }
   }

   console.log('[feFmtLbl] Parsed definition as: ' + JSON.stringify(this._ast));


}

FE$FormattedLabelRenderer.prototype.onEvent = function (event, data, control) {
   if (event == this.getProxy().Events.CHANGE) {
      this.translateTo(this.getLanguage());
   } else if (event == this.getProxy().Events.FORMREADY) {
      console.log('[feFmtLbl] Received form ready event: ' + this.getProxy().Events.FORMREADY);
      this.translateTo(this.getLanguage());
   }
}

/* -------------------- HIDDEN RENDERER ----------------------- */
function FE$HiddenRenderer() {
   this._ast = null;
   this._value = null;
}
FE$HiddenRenderer.prototype = new FE$BaseRenderer();

FE$HiddenRenderer.prototype.getType = function () {
   return 'hidden';
}

FE$HiddenRenderer.prototype.isValueControl = function () {
   return true;
}

FE$HiddenRenderer.prototype.recalculate = function () {
   var def = this.getDefinition();

   this._value = this.getProxy().fexExecuteAST(this._ast);
}

FE$HiddenRenderer.prototype.render = function (where, lang) {
   // Do nothing
   var def = this.getDefinition();

   // Compile
   if (def.value) {
      var proxy = this.getProxy();

      this._ast = proxy.fexParseAST(def.value);
      var ids = proxy.fexGetASTIdentifiers(this._ast);
      for (var j = 0; j < ids.length; j++) {
         console.log('[feHdn] Subscribing to ' + ids[j]);
         this.subscribeToChangesOn(ids[j]);
      }
   }

   console.log('[feHdn] Parsed definition as: ' + JSON.stringify(this._ast));

   this.recalculate();
}

FE$HiddenRenderer.prototype.getValue = function () {
   return this._value;
}

FE$HiddenRenderer.prototype.onEvent = function (event, data, control) {
   if (event == this.getProxy().Events.CHANGE) {
      this.recalculate();
   }
}

/* -------------------- Time RENDERER ----------------------- */
function FE$TimeRenderer() {
   this._value = null;
}
FE$TimeRenderer.prototype = new FE$BaseRenderer();

FE$TimeRenderer.prototype.getType = function () {
   return 'time';
}

FE$TimeRenderer.prototype.isValueControl = function () {
   return true;
}

FE$TimeRenderer.prototype.render = function (where, lang) {

   this._value = new Date().toLocaleString().substring(11, 16);

   let label = document.createElement('label');
   where.appendChild(label);
   label.appendChild(document.createTextNode(this._value))
}

FE$TimeRenderer.prototype.getValue = function () {
   return this._value;
}

/* --- Time Validator --- */
function FE$TimeValidator() { }
FE$TimeValidator.prototype = new FE$BaseValidator();

FE$TimeValidator.prototype.getType = function () {
   return 'timePar';
}
FE$TimeValidator.prototype.validate = function (value, configuration, translationSvc, lang) {

   if (parseInt(value.split(':')[1]) % 2 != 0) {
      var msg = configuration.message;
      var ret = translationSvc(msg, lang);
      return ret;
   }
   return null;
}

/* ---- REGISTRATIONS ---- */
fe$ngine.register(FE$TimeRenderer);
fe$ngine.register(FE$TimeValidator);
fe$ngine.register(FE$TextRenderer);
fe$ngine.register(FE$LongTextRenderer);
fe$ngine.register(FE$ChoiceRenderer);
fe$ngine.register(FE$RadioChoiceRenderer);
fe$ngine.register(FE$ButtonRenderer);
fe$ngine.register(FE$LabelRenderer);
fe$ngine.register(FE$ImageRenderer);
fe$ngine.register(FE$NativeImageRenderer);
fe$ngine.register(FE$CheckRenderer);
fe$ngine.register(FE$BoxedCheckRenderer);
fe$ngine.register(FE$DateRenderer);
fe$ngine.register(FE$SimpleDateRenderer);
fe$ngine.register(FE$SubmitRenderer);
fe$ngine.register(FE$StylizedChoiceRenderer);
fe$ngine.register(FE$AutoCompleteChoiceRenderer);
fe$ngine.register(FE$StylizedRadioChoiceRenderer);
fe$ngine.register(FE$StylizedCheckRenderer);
fe$ngine.register(FE$MultiChoiceRenderer);
fe$ngine.register(FE$HardcodedFooterRenderer);
fe$ngine.register(FE$InvitationRenderer);
fe$ngine.register(FE$MultiboxRenderer);
fe$ngine.register(FE$UploadRenderer);
fe$ngine.register(FE$FormattedLabelRenderer);
fe$ngine.register(FE$HiddenRenderer);
fe$ngine.register(FE$MultiLevelChoiceRenderer);
fe$ngine.register(FE$ToastRenderer);

export { FE$HardcodedFooterRenderer };
